/* eslint-disable react-hooks/rules-of-hooks */
import { React, useEffect, useState } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import {
  RightLayoutContainer,
  PageTitleComp,
  DetailFields,
  ResultWrap,
  TableLayoutData,
  HaberForm,
  SolutionContainer,
} from "../../styledElements";
import {
  Button,
  PageHeader,
  Tabs,
  Row,
  Col,
  Table,
  Tooltip,
  Input,
  Form,
  Skeleton,
  Collapse,
  Radio
} from "antd";
import { RadioButtonStyle, Styled } from "../../pageStyled";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertBlue from "../../../Assets/Icons/alertBlue.svg";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import warning from "../../../Assets/Icons/warning.png";
import Iconmoon from "../../../Components/IconsFiles/icon";
import PrintIcon from "../../../Assets/Icons/printer2.svg";
import Mapping from "../../../Assets/Icons/maping.svg";
import MappingEdit from "../../../Assets/Icons/maping-edit.svg";
import CloseProduction from "../../../Assets/Icons/close-production.svg";
import { getOrdersList } from "../../../Services/orderServices";
import moment from "moment";
import { TableList, JobCardColorStatus } from "../../pageStyled";
import JobCardCylinderContainer from "../../../Components/JobCardCylinders/JobCardCylinderContainer";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import ParentReelJobCardDrawer from "./JobcardDrawers/parentReelJobCardDrawer";
import ClosedProductionDrawer from "./JobcardDrawers/closedProductionDrawer";
import MapToJumboDrawer from "./JobcardDrawers/mapToJumboDrawer";
import CancelProductionDrawer from "./JobcardDrawers/cancelProductionDrawer";
import { getStocksDetailsByIds } from "../../../Services/productServices";
import {
  changeProductionJobCardState,
  getJumboReelDetailsById,
  getProductionJobCardsByIdMultistage,
} from "../../../Services/productionPlanningServices";
import CancelJobCardDrawer from "./JobcardDrawers/cancelJobCardDrawer";
import ViewDeckleOrder from "../../DeckleMatching/DeckleOrderDrawer/viewDeckleOrder";
import {
  CoversionFactorCMToUnits,
  CoversionFactorUnitsToCM,
  lengthUnit,
  weightUnit,
} from "../../../Utils/Constant/MeasurementUnitList";
import { getIntermediateList } from "../../../Services/deckleMatchServices";
// import Form from "antd";
import { getUnitData } from "../../../Services/measurementService";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import styled from "styled-components";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";
import JobCardCylinderContainerMultistage from "../../../Components/JobCardCylinders/JobCardCylinderContainerMultistage";
import SheetJobCardCylinderContainerMultistage from "../../../Components/JobCardCylinders/SheetJobCardCylinderContainerMultistage";
import { toHandlePOName } from "../../../Utils/helper/helper";

const CardShimmerStyle = styled.div`
.ant-card-body {
    position: relative;
    z-index: 0;
    overflow: hidden;
    height: 100%;
    padding : 0px;
}
.ant-skeleton-element .ant-skeleton-button {
    min-width:0px;
    width:100%;
    border-radius : 3px;
    }
    .ant-skeleton-element .ant-skeleton-input {
        min-width:0px;
        width:100%;
        border-radius : 3px;
        }
        .ant-skeleton-element {
            width:100%;
        }
`;

const Panes = Tabs.TabPane;


const ProductionJobcardDetailsMultistage = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  let [searchParams, setSearchParams] = useSearchParams();
  const [jobId, setJobId] = useState(
    location.state ? location.state.id : searchParams.get("id")
    );
    const[isDrawerOpened, setDrawerOpen] = useState(location.state ? location.state.openDrawer : false);
    const[parentWeight, setParentWeight] = useState(location.state ? location?.state?.parentWeight : "");
    const[parentWeightUnit, setParentWeightUnit] = useState(location.state ? location?.state?.parentWeightUnit : "");
    const [jobCard, setJobCard] = useState();
    const [acceptedSolution, setAcceptedSolution] = useState({
      name: null,
      key: null,
      solution: null,
    });
    const [products, setProducts] = useState();
    const [jumboReelData, setJumboReelData] = useState();
    const [fulfilledOrdersList, setFulfilledOrdersList] = useState([]);
    const [unfulfilledOrdersList, setUnfulfilledOrdersList] = useState([]);
    const [selectedParentReel, setSelectedParentReel] = useState(location?.state?.parentReelId ? location?.state?.parentReelId : "");
    const [resp, setResp] = useState(location?.state?.data ? location?.state?.data : "");
    const [type, setType] = useState(location.state ? location.state.type : "");
    const [savedDate, setDate] = useState(location.state ? location.state.selectedDate : "");
    const [savedShift, setShift] = useState(location.state ? location.state.selectedShift : "");
    const [selectedMachineType, setMachineType] = useState(location.state ? location.state.machineType : "");
    const [activeTab, setActiveTab] = useState("1");
    const [disableCancel, setDisableCancel] = useState(false);
    const [disablePrint, setDisablePrint] = useState(true);
    const [orderDetailsList, setOrderDetailsList] = useState();
    const [reFetch, setReFetch] = useState(true);
    const [reFetchJumboReels, setReFetchJumboReels] = useState(true);
    const [visible, setVisible] = useState(false);
    const [visibleHold, setVisibleHold] = useState(false);
    const [viewCancelJobCardDrawer, setViewCancelJobCardDrawer] = useState(false);
    const [disableHoldPoduction, setDisableHoldProduction] = useState(false);
    const [diameterFulfilmentArray, setDiameterFulfilmentArray] = useState([]);
    const [viewParentReelJobCardDrawer, setViewParentReelJobCardDrawer] =
    useState(false);
    const [viewCloseProductionDrawer, setViewCloseProductionDrawer] =
    useState(false);
    const [viewMapToReelDrawer, setViewMapToReelDrawer] = useState(false);
    const [viewCancelProductionDrawer, setViewCancelProductionDrawer] =
    useState(false);
    const [actionResponse, setActionResponse] = useState();
    const [toaster, setToaster] = useState(false);
    const [viewOrder, setViewOrder] = useState(false);
    const [selectedOrderNo, setSelectedOrderNo] = useState();
    const [selectedOrder,setSelectedOrder]= useState();

    const [producedParentReelBool, setProducedParentReelBool] = useState(false);
    const [userDetails, setUserDetails] = useState(
      JSON.parse(localStorage.getItem("user-details"))
      );
      const [sizeFulfillmentDetailsList, setSizeFulfillmentDetailsList] =
    useState();
  const [loadings, setLoadings] = useState(false);
  const history = useNavigate();
  const [intermediateData, setIntermediateData] = useState([]);
  const [isParentReelCancelled, setIsParentReelCancelled] = useState(false);
  const [isValidState, setIsValidState] = useState(false);
  const [isSetCancelled, setIsSetCancelled] = useState(false);
  const [unitData,setUnitData] = useState();
  const [isMapJumboLoading, setIsMapJumboLoading] = useState(false);
  const [isProduced, setIsProduced] = useState(false);
  const [totalFulfilledOrders, setTotalFulfilledOrders] = useState(0);
  const [totalUnfulfilledOrders, setTotalUnfulfilledOrders] = useState(0);
  const [isFetchingData, setIsFetchingData] = useState(false);
  const [isFetchingDataForCylinder, setIsFetchingDataForCylinder] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isSheetView, setIsSheetView] = useState(true);
  const [isJobcardView, setIsJobcardView] = useState(true);
  const [isTabularView, setIsTabularView] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [isCancelLoading, setIsCancelLoading] = useState(false);
  const [isHoldLoading, setIsHoldLoading] = useState(false);
  const [jobCardDetailsListForPrint, setJobCardDetailsListForPrint] = useState()
  const [isPrintDisabled, setIsPrintDisabled] = useState(false);
  const routeChange = (record) => {
    // console.log(jobId, record.parentReel);
    history("./print-parent-reel/pdf", {
      state: {
        jobId: jobId,
        parentReel: record.parentReel,
        machine_type: record.machine_type ? record.machine_type : "rewinder",
      },
    });
  };
  const onPaginationChange = (page, pageSize, isUnfulfilled) => {
    // console.log(page, pageSize);
    setCurrentPage(page);
    setPageSize(pageSize);
    // isUnfulfilled && setIsUnfulfilledTab(true);
  };
  function onChange(pagination, filters, sorter, extra) {
    // console.log("params", pagination, filters, sorter, extra);
    if (pagination) onPaginationChange(pagination.current, pagination.pageSize);
  }
  const handleViewChange = (e) => {
    // setGridView(e.target.value);
    if (e.target.value === "both") {
      setIsJobcardView(true);
      setIsSheetView(true);
    } else if (e.target.value === "reel") {
      setIsJobcardView(true);
      setIsSheetView(false);
    } else {
      setIsJobcardView(false);
      setIsSheetView(true);
    }
    // console.log("view check", e.target.value);
  };

  useEffect(() => {}, [isTabularView]);
  const handleViewChangeGrid = (e) => {
    setIsTabularView(e.target.value === "list");
  };
  const filterViewData = [
    {
      label: (
        <Tooltip
          placement="bottomRight"
          title={"View rewinding and sheeting plan"}
          className="edit-tooltip"
        >
          <span
            style={{
              transform: "translateY(-5px)",
              color: isJobcardView && isSheetView && "#ea655b",
              fontFamily: "var(--sf-pro-display) !important"
            }}
          >
            All
          </span>
          {/* <Iconmoon icon="sheet" size={20} color="#EA655B" /> */}
        </Tooltip>
      ),
      value: "both",
    },

    {
      label: (
        <Tooltip
          placement="bottomRight"
          title={"View rewinding plan"}
          className="edit-tooltip"
        >
          <Iconmoon icon="tissue-role" size={18} color="#EA655B" />
        </Tooltip>
      ),
      value: "reel",
    },
    {
      label: (
        <Tooltip
          placement="bottomRight"
          title={"View sheeting plan"}
          className="sheet"
        >
          <Iconmoon icon="sheet" size={20} color="#EA655B !important" />
        </Tooltip>
      ),
      value: "sheet",
    },
  ];
  const gridViewData = [
    {
      label: (
        <Tooltip
          placement="bottomRight"
          title={"View in grid mode"}
          className="edit-tooltip"
        >
          <Iconmoon icon="grid-chart" size={20} color="#EA655B" />
        </Tooltip>
      ),
      value: "grid",
    },
    {
      label: (
        <Tooltip
          placement="bottomRight"
          title={"View in tabular mode"}
          className="edit-tooltip"
        >
          <Iconmoon icon="table" size={20} color="#EA655B" />
        </Tooltip>
      ),
      value: "list",
    },
  ];
  function calculateDeckleSize(job) {
    const machine = job?.jobcard?.group?.machines[0];

    if (machine) {
      const deckleSizeUB = machine.deckle_size_ub || 0;
      const leftEdgeTrim = machine.left_edge_trim || 0;
      const rightEdgeTrim = machine.right_edge_trim || 0;

      const lengthUnitDisplayName =
        lengthUnit[machine.units?.deckle_size_ub]?.displayName ||
        "";

      const totalValue =
        (
          deckleSizeUB +
          (leftEdgeTrim + rightEdgeTrim) *
            CoversionFactorUnitsToCM[machine.units?.right_edge_trim] *
            CoversionFactorCMToUnits[machine.units?.deckle_size_ub]
        )?.toFixed(3) || 0;

      const deckleSizeLB = machine.deckle_size_lb?.toFixed(3) || 0;

      return `${deckleSizeUB} - ${deckleSizeLB} ${lengthUnitDisplayName}`;
    }

    return "";
  }

  const fetchOrdersForPrint = async () => {
    setIsPrintDisabled(true);
    let orderList = [];
    const ordersList = acceptedSolution.solution.data.orders
      ?.filter((order) => {
        return order.item_type == "order";
      })
      ?.map((item) => item.order_id);
      
    ordersList &&
      getOrdersList(ordersList)
        .then((response) => {
          orderList = response.data?.map((item, index) => {
            // console.log("aacccceeppttt", acceptedSolution);
            const orderData = acceptedSolution?.solution?.data?.orders?.filter(
              (order) => parseFloat(order.order_id) === item.number
            )[0];
            // console.log("orderr", orderData);
            let unitValue = orderData.units ? orderData.units : {};
            
            unitValue['fulfilled_weight'] = unitValue?.fulfilled_weight ? unitValue?.fulfilled_weight : unitData.units_management.weight.default;
   
            return {
              key: index + 1,
              pono: `${item.po}`,
              sono:`${item.so}`,
              category:item.category,
              orderno: `${item.number}`,
              type: "Order",
              customercode: item.customer,
              customername: item.customer_name,
              customer_alias: item.customer_alias,
              consignee: item.consignee_name,
              productspec: item.product_spec,
              size: `${item.width}${item.length ? ` x ${item.length}` : ""
                } ${" "} ${item?.units && item?.units?.width
                  ? lengthUnit[item.units.width]?.displayName?.toUpperCase()
                  : "CM"
                }`,
              productInfo: item.product_info,
              plannedReels: orderData.requirement,
              plannedWeight:
                orderData.requirement?.toFixed(3) +
                " " +
                (orderData?.units && orderData.units.requirement
                  ? weightUnit[
                    orderData.units.requirement
                  ]?.displayName.toUpperCase()
                  : "T"),
              fulflilledReels: orderData.fulfilled,
              fulflilledWeight:
                orderData.fulfilled_weight?.toFixed(3) +
                " " +
                (orderData?.units && orderData?.units?.fulfilled_weight
                  ? weightUnit[
                    orderData.units.fulfilled_weight
                  ]?.displayName.toUpperCase()
                  : "T"),
              unFulflilledReels: orderData.unfulfilled,
              unFulflilledWeight:
                orderData.unfulfilled_weight?.toFixed(3) +
                " " +
                (orderData?.units && orderData?.units?.unfulfilled_weight
                  ? weightUnit[
                    orderData.units.unfulfilled_weight
                  ]?.displayName.toUpperCase()
                  : "T"),
              priority: item.forced,
              deliverydate: item.category==='so'?"-": moment(item.delivery_date).format("DD MMM YYYY"),
              remarks: item.remarks,
              reel_od: item.reel_od,
              core_id: item.core_id,
              consignee_name: item.consignee_name,
              consignee_code: item.consignee_code,
              plannedreel: "d",
              reelSpecification: orderData?.diameter_fulfillment?.map(
                (diaItem) => {
                  const reelOd = diaItem.reel_od;
                  const coreId = diaItem.core_id;
                  const fulfilledWeight = diaItem.fulfilled_weight?.toFixed(3);
                  const fulfilledValue = diaItem.fulfilled;
                  const fulfilledWeightUnit = capitalize(
                    orderData.units?.fulfilled_weight ? weightUnit[orderData.units?.fulfilled_weight].displayName : 'T'
                  );
                  return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R)\n`;
                }
              ),
              cancelledQty: orderData?.cancelled_diameter_fulfillment?.map((diaItem) => {
                const reelOd = diaItem.reel_od;
                const coreId = diaItem.core_id;
                const fulfilledWeight =
                  diaItem.fulfilled_weight?.toFixed(3);
                const fulfilledValue = diaItem.fulfilled;
                const fulfilledWeightUnit = capitalize(
                  orderData.units?.fulfilled_weight ? weightUnit[orderData.units?.fulfilled_weight].displayName : 'T'
                );
                return (fulfilledWeight && fulfilledValue) ? `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R) \n` : '-';
              }),
              diameter_fulfillment: orderData?.diameter_fulfillment?.map(
                (diaItem, index) => {
                  return {
                    reel_od: diaItem.reel_od,
                    core_id: diaItem.core_id,
                    fulfilled_weight: diaItem.fulfilled_weight - orderData?.cancelled_diameter_fulfillment[index].fulfilled_weight,
                    fulfilled: diaItem.fulfilled - orderData?.cancelled_diameter_fulfillment[index].fulfilled,
                    fulfilledWeightUnit:
                      orderData.units?.fulfilled_weight ? orderData.units?.fulfilled_weight : unitData.units_management.weight.default

                  }
                  
                }
              ),
              cancelled_diameter_fulfillment: orderData?.cancelled_diameter_fulfillment,
              fulfilled_quantity: orderData.fulfilled_weight - orderData.cancelled_weight,
              units: unitValue,
              matchedGrain: orderData?.grain,
              isReel : orderData.type === 'reel',
            };
          });

          const stockSizesList = acceptedSolution.solution.data.orders
            ?.filter((order) => {
              return order.item_type == "stock";
            })
            ?.map((item) => item.order_id);
          if (stockSizesList.length > 0) {
            getStocksDetailsByIds({ stocks: stockSizesList })
              .then((response) => {
                let sizesList = response.data?.map((item, index) => {
                  const orderData =
                    acceptedSolution.solution.data.orders.filter(
                      (order) => order.order_id === item.id
                    )[0];
                  let unitValue = orderData.units ? orderData.units : {};
                  unitValue['fulfilled_weight'] = unitValue?.fulfilled_weight ? unitValue?.fulfilled_weight : unitData.units_management.weight.default;
           
                  return {
                    key: index + 1,
                    pono: "-",
                    orderno: `${item.id}`,
                    type: "Stock",
                    customercode: "-",
                    customername: "-",
                    customer_alias: "-",
                    size: `${item.width}${item.length ? ` x ${item.length}` : ""
                      } ${" "} ${item.units && item.units?.width
                        ? lengthUnit[
                          item.units.width
                        ]?.displayName?.toUpperCase()
                        : "CM"
                      }`,
                    productInfo: item.product_info,
                    plannedReels: "-",
                    plannedWeight: "-",
                    fulflilledReels: orderData.fulfilled,
                    fulflilledWeight:
                      orderData.fulfilled_weight?.toFixed(3) +
                      " " +
                      (orderData?.units && orderData.units.fulfilled_weight
                        ? weightUnit[
                          orderData.units.fulfilled_weight
                        ]?.displayName.toUpperCase()
                        : "T"),
                    unFulflilledReels: "-",
                    unFulflilledWeight: "-",
                    priority: false,
                    deliverydate: "-",
                    remarks: "",
                    reel_od: item.reel_od,
                    core_id: item.core_id,
                    plannedreel: "ss",
                    reelSpecification: orderData?.diameter_fulfillment?.map(
                      (diaItem) => {
                        const reelOd = diaItem.reel_od;
                        const coreId = diaItem.core_id;
                        const fulfilledWeight =
                          diaItem.fulfilled_weight?.toFixed(3);
                        const fulfilledValue = diaItem.fulfilled;
                        const fulfilledWeightUnit = capitalize(
                          weightUnit[orderData.units?.fulfilled_weight]
                            ?.displayName
                        );
                        return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R)\n`;
                      }
                    ),
                    diameter_fulfillment: orderData?.diameter_fulfillment?.map(
                      (diaItem, index) => {
                        return {
                          reel_od: diaItem.reel_od,
                          core_id: diaItem.core_id,
                          fulfilled_weight: diaItem.fulfilled_weight - orderData?.cancelled_diameter_fulfillment[index].fulfilled_weight,
                          fulfilled: diaItem.fulfilled - orderData?.cancelled_diameter_fulfillment[index].fulfilled,
                          fulfilledWeightUnit: orderData.units?.fulfilled_weight ? orderData.units?.fulfilled_weight : unitData.units_management.weight.default

                        }
                        
                      }
                    ),
                    cancelled_diameter_fulfillment: orderData?.cancelled_diameter_fulfillment,
                    fulfilled_quantity: orderData.fulfilled_weight - orderData.cancelled_weight,
                    units: unitValue,
                    cancelledQty: orderData?.cancelled_diameter_fulfillment?.map((diaItem) => {
                      const reelOd = diaItem.reel_od;
                      const coreId = diaItem.core_id;
                      const fulfilledWeight =
                        diaItem.fulfilled_weight?.toFixed(3);
                      const fulfilledValue = diaItem.fulfilled;
                      const fulfilledWeightUnit = capitalize(
                        weightUnit[orderData.units?.fulfilled_weight]?.displayName
                      );
                      return (fulfilledWeight && fulfilledValue) ? `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R) \n` : '-';
                    }),
                  };

                });
                // console.log(orderList);

                setJobCardDetailsListForPrint([...orderList, ...sizesList]);
              })
              .catch((error) => console.log(error));
          } else {
            setJobCardDetailsListForPrint(orderList);
          }
        })
        .catch((error) => console.log(error))
        .finally(()=>setIsPrintDisabled(false))
  };
  useEffect(() => {
    setPageSize(10);
    setCurrentPage(1);
    setIsCancelLoading(false);
  },[activeTab])
  const printJobCard = (record) => {
    history("./print-job-card/pdf", {
      state: {
        jobId: jobId,
        machine_type: record.jobcard.group.machines[0].machine_type
          ? record.jobcard.group.machines[0].machine_type
          : "rewinder",
      },
    });
  };
  useEffect(() => {
    setReFetch(true);
    setReFetchJumboReels(true);
  }, [isSetCancelled]);

  // useEffect(() => {

  // }, [location.state]);

  const printJobCardDetails = () => {
    history("./print-pdf", {
      state: { jobId: jobId, solution: acceptedSolution.key, orderDetailsList:jobCardDetailsListForPrint },
    });
  };
  const isCancelLoadingToggle = (isFetching) => {
    if (isFetching) setIsCancelLoading(true);
    else {
      setIsCancelLoading(false);
    }
  }

  useEffect(() => {
    // console.log(isHoldLoading, isCancelLoading)
  },[isCancelLoading, isHoldLoading])
  // Column heads
  const columnsHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "7%",
      fixed: "left",
      align: "center",
      render: (text, record) => {
  const value =
    record.category === "po"
      ? toHandlePOName(record.pono)
      : record.category === "so"
      ? toHandlePOName(record.sono)
      : toHandlePOName(record.pono);

  return (
    <span style={{ whiteSpace: "normal", wordBreak: "break-word", lineHeight: "1.4" }}>
      {value
        ?.match(/.{1,15}/g)
        ?.map((chunk, index) => (
          <span key={index}>
            {chunk}
            <br />
          </span>
        ))}
    </span>
  );
}

    },
    {
      title: "Order No/Stock No",
      dataIndex: "orderno",
      width: "7%",
      fixed: "left",
    },
    {
      title: "Type",
      dataIndex: "type",
      width: "7%",
      fixed: "left",
    },
    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "10%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.customercode}-${record.customername}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.customer_alias||'-'}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee",
      width: "10%",
      render: (text, record) => (
        record?.consignee_name||'-'
      )
    },
    {
      title: (
        <div>
          Product Spec
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "productspec",
      width: "14%",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },
    // {
    //   title: "Planned Reels",
    //   dataIndex: "plannedReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    {
      title: "Matched Grain",
      dataIndex: "matchedGrain",
      width: "10%",
      render: (text, record) =>
        !record.isReel ? <div>{text}</div> : "-",
    },
    {
      title: "Planned Quantity",
      dataIndex: "plannedWeight",
      width: "10%",
    },
    // {
    //   title: "Fulfilled Reels",
    //   dataIndex: "fulflilledReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    {
      title: "Fulfilled Quantity",
      dataIndex: "fulflilledWeight",
      width: "10%",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "5%",
    // },
    {
      title: "REEL SPECIFICATION",
      dataIndex: "reelSpecification",
      width: "22%",
      render: (text, record) => (
        record.isReel? <div
          dangerouslySetInnerHTML={{
            __html: String(text).replace(/\n/g, "<br />"),
          }}
        /> : '-'
      ),
    },
    {
      title: "Del Date",
      dataIndex: "deliverydate",
      width: "10%",
    },
    {
      title: "Cancelled Quantity",
      dataIndex: "cancelledQty",
      width: "22%",
      render: (text) => (
        isParentReelCancelled ? <div
          dangerouslySetInnerHTML={{
            __html: String(text).replace(/\n/g, "<br />"),
          }}
        />
        : '-'
      ),
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "8%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={record.remarks}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button style={{ cursor: "default" }}>
                <Iconmoon icon="message" size={16} color="#EA655B" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "7%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View details of this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button onClick={() => showViewDrawer(record.orderno,record)}>
                <Iconmoon icon="file-view" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
  ];

  const intermediateColumnsHead = [
    {
      title: "Sr.No",
      dataIndex: "srno",
      width: 6,
      fixed: "left",
      align: "center",
    },
    {
      title: "Reel Size",
      dataIndex: "reel_size",
      width: 8,
      fixed: "left",
      align: "center",
    },
    {
      title: "Order Size (WxL)",
      dataIndex: "order_size",
      width: 10,
      align: "center",
    },
    {
      title: "Matched Grain",
      dataIndex: "grain",
      width: 8,
      align: "center",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      width: 8,
      align: "center",
    },
    {
      title: "REEL SPECIFICATION",
      dataIndex: "reelSpecification",
      width: 16,
      align: "center",
      render: (text) => (
        <div
          dangerouslySetInnerHTML={{
            __html: String(text).replace(/\n/g, "<br />"),
          }}
        />
      ),
    },
  ];

  const unfulfilledColumnsHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "7%",
      fixed: "left",
      align: "center",
      render: (text, record) => {
  const value =
    record.category === "po"
      ? toHandlePOName(record.pono)
      : record.category === "so"
      ? toHandlePOName(record.sono)
      : toHandlePOName(record.pono);

  return (
    <span style={{ whiteSpace: "normal", wordBreak: "break-word", lineHeight: "1.4" }}>
      {value
        ?.match(/.{1,15}/g)
        ?.map((chunk, index) => (
          <span key={index}>
            {chunk}
            <br />
          </span>
        ))}
    </span>
  );
}


    },
    {
      title: "Order No/Stock No",
      dataIndex: "orderno",
      width: "7%",
      fixed: "left",
    },
    {
      title: "Type",
      dataIndex: "type",
      width: "7%",
      fixed: "left",
    },
    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "10%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.customercode}-${record.customername}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.customer_alias||'-'}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee",
      width: "10%",
      render: (text, record) => (
        record?.consignee_name||'-'
      )
    },
    {
      title: (
        <div>
          Product Spec
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "productspec",
      width: "14%",
    },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },
    // {
    //   title: "Planned Reels",
    //   dataIndex: "plannedReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    {
      title: "Matched Grain",
      dataIndex: "matchedGrain",
      width: "8%",
      render: (text, record) => `${!record.isReel  ? text : "-"}`,
    },
    {
      title: "Planned Quantity",
      dataIndex: "plannedWeight",
      width: "10%",
    },
    // {
    //   title: "Unfulfilled Reels",
    //   dataIndex: "unFulflilledReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    {
      title: "Unfulfilled Quantity",
      dataIndex: "unFulflilledWeight",
      width: "10%",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "5%",
    // },
    {
      title: "Del Date",
      dataIndex: "deliverydate",
      width: "10%",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      width: "8%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={record.remarks}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button style={{ cursor: "default" }}>
                <Iconmoon icon="message" size={16} color="#EA655B" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "7%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View details of this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button onClick={() => showViewDrawer(record.orderno,record)}>
                <Iconmoon icon="file-view" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
  ];
  const sizeFulfillmentColumnsHead = [
    {
      title: "Sr.No",
      dataIndex: "key",
      width: "7%",
      fixed: "left",
      align: "center",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "7%",
    //   fixed: "left",
    // },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "9%",
    },
    {
      title: "Matched Grain",
      dataIndex: "grain",
      width: "10%",
      // render: (record, text) => (
      //   record.type == 'Sheet' ?
      // )
    },
    {
      title: "Planned Quantity",
      dataIndex: "plannedWeight",
      width: "10%",
    },
    {
      title: "Fulfilled Quantity",
      dataIndex: "fulflilledWeight",
      width: "10%",
    },
    {
      title: "UnFulfilled/(Overfulfilled) Quantity",
      dataIndex: "unFulflilledWeight",
      width: "10%",
      render: (text, record) => {
        const parsedValue = parseFloat(text?.split(" ")[0]);
        const positiveValue = Math.abs(parsedValue);
        return parsedValue < 0 ? (
          <div>
            ({positiveValue} {text?.split(" ")[1]})
          </div>
        ) : (
          text
        );
      },
    },
    {
      title: "REEL SPECIFICATION",
      dataIndex: "reelSpecification",
      width: "25%",
      render: (text) => (
        <div
          dangerouslySetInnerHTML={{
            __html: String(text).replace(/\n/g, "<br />"),
          }}
        />
      ),
    },
    // {
    //   title: "Planned Reels",
    //   dataIndex: "plannedReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    // {
    //   title: "Fulfilled Reels",
    //   dataIndex: "fulflilledReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
    // {
    //   title: "Unfulfilled Reels",
    //   dataIndex: "unFulflilledReels",
    //   width: "8%",
    //   // render: (text, record) => `${text} ${capitalize(record.type)}s`,
    // },
  ];
  const mapJumboReelColumns = [
    {
      title: "Combination No.",
      dataIndex: "combination_no",
      width: "9%",
      align: "center",
    },
    {
      title: "Combination",
      dataIndex: "combinations",
      width: "25%",
      sorter: {
        compare: (a, b) => {},
      },
      render: (text, record) => (
        <div className="combination-rl">
          {record.machine_type !== "cutter" ? (
            <h4>
              {text?.map(
                (item, index, array) =>
                  `${item.width} ${index + 1 !== array.length ? "+" : ""}`
              )}
              {record.priority && <span dataset="Priority">Priority</span>}
            </h4>
          ) : (
            <h4>
              {`(`}
              {text?.map(
                (item, index) =>
                  `${item.width} ${index + 1 !== text.length ? "+" : ""}`
              )}{" "}
              {`) X ${text[0].length}`}
              {record.priority && <span dataset="Priority">Priority</span>}
            </h4>
          )}

          {record.core_id &&
          record.reel_od &&
          record.machine_type !== "cutter" ? (
            <p>Parent Reel: {record.parentReel}</p>
          ) : (
            <p>Parent Set: {record.parentReel}</p>
          )}
        </div>
      ),
    },
    {
      title: "Reel OD/ Core OD",
      dataIndex: "diaValue",
      width: "9%",
      align: "center",
    },
    {
      title: "Chop Size",
      dataIndex: "chop_size",
      width: "9%",
      align: "center",
      render: (text, record) =>
        `${text} ${" "} ${
          record?.units && record?.units?.length
            ? lengthUnit[record.units.length]?.displayName?.toUpperCase()
            : "CM"
        }`,
    },
    {
      title: "D.Com.Width",
      dataIndex: "comWidth",
      width: "9%",
      align: "center",
      render: (text, record) =>
        `${text} ${" "} ${
          record?.units && record?.units?.d_com_width
            ? lengthUnit[record.units.d_com_width]?.displayName?.toUpperCase()
            : "CM"
        }`,
    },
    {
      title: "TRIM LOSS",
      dataIndex: "trimLoss",
      width: "8%",
      align: "center",
      render: (text, record) =>
        `${text.toFixed(3)} ${" "} ${
          record?.units && record?.units?.trim_loss
            ? lengthUnit[record.units.trim_loss]?.displayName?.toUpperCase()
            : "CM"
        }`,
    },
    {
      title: (
        <div>
          NET TRIM LOSS
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={"Net trim loss including the edge trim"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "netTrimLoss",
      width: "8%",
      align: "center",
      render: (text, record) =>
        `${text.toFixed(3)} ${" "} ${
          record?.units && record?.units?.net_trim_loss
            ? lengthUnit[record.units.net_trim_loss]?.displayName?.toUpperCase()
            : "CM"
        }`,
    },
    {
      title: (
        <div>
          EARLIEST DELIVERY <br/> DATE
        </div>
      ),
      dataIndex: "deliverydate",
      width: "19%",
      align: "center",
      sorter: {
        compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
      },
      render: (text) => moment(text).format("DD MMM YYYY"),
    },
    {
      title: "MAPPED JUMBO ROLL",
      dataIndex: "mappedJumboRoll",
      width: "15%",
      align: "center",
      render: (text) => {
        return text.length === 0
          ? "-"
          : text?.map(
              (item, index, array) =>
                `${item.number}${index + 1 != array.length ? ", " : ""}`
            );
      },
    },
    {
      title: "PRODUCTION STATUS",
      dataIndex: "status",
      width: "13%",
      render: (text, record) => (
        <div className="statusVal" dataval={record.status}>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={
                record.reel_od && record.core_id
                  ? text === "Produced"
                    ? "The production of this parent reel is completed"
                    : text === "Mapped"
                    ? "This parent reel is mapped to jumbo roll for rewinding"
                    : text === "Not Mapped"
                    ? "This parent reel is not mapped to jumbo roll yet"
                    : text === "Cancelled"
                    ? "The production of this parent reel is cancelled"
                    : null
                  : text === "Produced"
                  ? " The production of this parent set is completed"
                  : text === "Mapped"
                  ? "The parent set has been mapped to a jumbo roll"
                  : text === "Not Mapped"
                  ? "The parent set is not mapped to a jumbo roll yet"
                  : text === "Cancelled"
                  ? "The production of this parent set is cancelled"
                  : text === "Rejected"
                  ? "The production of this parent set is rejected "
                  : null
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {text}
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "ACTIONS",
      dataIndex: "action",
      width: "15%",
      align: "center",
      render: (text, record) => (
        <div
          className="actionBtn"
          style={{ display: "flex", justifyContent: "end" }}
        >
          {userDetails.roles.production.job_cards.edit &&
            record.status === "Not Mapped" &&
            jobCard.state !== "hold" && (
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={"Map jumbo roll"}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Button onClick={() => showMapToReel(record.parentReel, "add")}>
                    <img style={{ width: "18px" }} src={Mapping} />
                  </Button>
                </Tooltip>
              </Styled>
            )}
          {userDetails.roles.production.job_cards.edit &&
            record.status === "Mapped" &&
            jobCard.state !== "hold" && (
              <>
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={"Edit jumbo roll mapping"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button onClick={() => showMapToReel(record.parentReel, "edit")}>
                      <img style={{ width: "18px" }} src={MappingEdit} />
                    </Button>
                  </Tooltip>
                </Styled>
                <Styled>
                  <Tooltip
                    placement="bottomRight"
                    title={"Close production for the parent reel"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => showCloseProduction(record.parentReel)}
                    >
                      <img style={{ width: "17px" }} src={CloseProduction} />
                    </Button>
                  </Tooltip>
                </Styled>
              </>
            )}
          {record.status === "Mapped" && jobCard.state !== "hold" && (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"Print details of the parent reel"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button onClick={() => routeChange(record)}>
                  <img style={{ width: "20px" }} src={PrintIcon} />
                </Button>
              </Tooltip>
            </Styled>
          )}
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View parent reel details"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button onClick={() => showParentReelJobCard(record.parentReel, record.status==='Produced' || record.status ==="Rejected")}>
                <Iconmoon icon="file-view" size={16} color="#605E5C" />
              </Button>
            </Tooltip>
          </Styled>
          {((record.status !== "Cancelled" && record.status !== "Rejected" &&
            record?.machine_type === "rewinder") ||
          (record.status === "Open" &&
          record?.machine_type === "cutter")) &&
          userDetails.roles.production.job_cards.edit && record.status!=='Produced' && jobCard.state !== "hold" && (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"Cancel Production For This Parent Reel"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button onClick={() => onCloseParentReelCancel(record.parentReel)}>
                <Iconmoon icon="wrong" size={16} color="#605E5C" />
              </Button>
              </Tooltip>
            </Styled>
          )}
        </div>
      ),
    },
  ];
 
  const tabChange = (key) => setActiveTab(key);

  const getIntermediateListItems = (
    ordersList,
    jobcard,
    solution,
    isNewSolution
  ) => {
    // console.log(jobIndex, jobCardDetailsList[jobIndex]);
    getIntermediateList(ordersList, jobcard, solution).then((response) => {
      // console.log(response);
      if (!response) return;
      const intermediateDataTemp = response?.map((item, index) => {
        const reelSpecifications = item.reel_specification?.map((spec) => {
          const outerDiameters = Array.isArray(spec?.reel_od)
            ? spec.reel_od.join(", ")
            : spec.reel_od;
          return `${outerDiameters} / ${
            spec?.core_id
          } (${spec?.fulfilled_weight?.toFixed(3)} ${weightUnit[
            spec?.units?.fulfilled_weight
          ]?.displayName?.toUpperCase()}, ${spec.fulfilled}R)`;
        });

        return {
          key: index,
          srno: index + 1,
          reel_size: `${item.reel_size} ${lengthUnit[
            item.units.reel_size
          ]?.displayName?.toUpperCase()}`,
          order_size: item.length ? `${item.width}${lengthUnit[
            item.units.width
          ]?.displayName?.toUpperCase()} x ${item.length} ${lengthUnit[
            item.units.length
          ]?.displayName?.toUpperCase()}` : `${item.width}${lengthUnit[item.units.width]?.displayName?.toUpperCase()}`,
          grain: item.grain,
          quantity: `${item.quantity?.toFixed(3)} ${weightUnit[
            item.units.quantity
          ]?.displayName?.toUpperCase()}`,
          reelSpecification: reelSpecifications?.join("\n"),
        };
      });

      setIntermediateData(intermediateDataTemp);
    });
  };

  const holdProduction = () => {
    setIsHoldLoading(true)
    changeProductionJobCardState({ id: jobId, state: "hold" })
      .then((response) => {
        setActiveTab("1");
        setActionResponse(response);
        setReFetch(true);
        showToaster();
      })
      .catch((error) => {
        setActionResponse(error.response.data);
        showToaster();
      }).finally(()=>setIsHoldLoading(false));
  };

  const completeProduction = () => {
    changeProductionJobCardState({ id: jobId, state: "complete" })
      .then((response) => {
        setActiveTab("1");
        setActionResponse(response);
        setReFetch(true);
        showToaster();
      })
      .catch((error) => {
        setActionResponse(error.response.data);
        showToaster();
      });
  };

  const resumeProduction = () => {
    changeProductionJobCardState({ id: jobId, state: "in_production" })
      .then((response) => {
        setActiveTab("1");
        setActionResponse(response);
        setLoadings(false);
        setReFetch(true);
        
        showToaster();
      })
      .catch((error) => {
        setActionResponse(error.response.data);
        showToaster();
      });
  };

  const showToaster = () => {
    setToaster(true);
    setTimeout(() => {
      setToaster(false);
      setActionResponse();
    }, 2000);
  };

  const showModal = () => {
    setVisible(true);
  };
  const closeModal = () => {
    setVisible(false);
  };
  const modalConfirm = () => {
    setLoadings(true);
    resumeProduction();
    setVisible(false);
  };

  const holdModalShow = () => {
    setVisibleHold(true);
  };
  const holdModalClose = () => {
    setVisibleHold(false);
    // setIsHoldLoading(false);
  };
  const holdModalConfirm = () => {
    holdProduction();
    setVisibleHold(false);
    // setIsHoldLoading(false);
  };

  // const cancelModalShow = () => {
  //   setVisibleCancel(true);
  // };
  // const cancelModalClose = () => {
  //   setVisibleCancel(false);
  // };
  // const cancelModalConfirm = () => {
  //   setVisibleCancel(false);
  // };
  const onCancelSuccess = () => {
    setActiveTab("1");
  };

  const showCancelJobCardDrawer = () => {
    setViewCancelJobCardDrawer(true);
    // setIsCancelLoading(true);
  };

  const closeCancelJobCardDrawer = () => {
    setViewCancelJobCardDrawer(false);
    // setActiveTab(activeTab);
    // setIsCancelLoading(false);
  };

  const closeParentReelJobCard = () => {
    setSelectedParentReel();
    setViewParentReelJobCardDrawer(false);
    setIsProduced(false);
  };
  const showParentReelJobCard = (id, isProduced) => {
    setSelectedParentReel(id);
    setViewParentReelJobCardDrawer(true);
    setIsProduced(isProduced);
  };

  const closeProduction = () => {
    setSelectedParentReel();
    setViewCloseProductionDrawer(false);
  };
  const showCloseProduction = (id) => {
    setSelectedParentReel(id);
    setType("close");
    setViewCloseProductionDrawer(true);
  };

  const closeMapToReel = () => {
    setSelectedParentReel();
    setViewMapToReelDrawer(false);
    setDrawerOpen(false);
  };
  const showMapToReel = (id, actionType) => {
    setSelectedParentReel(id);
    setViewMapToReelDrawer(true);
    setType(actionType);
  };

  const closeCancelProduction = () => {
    setSelectedParentReel();
    setViewCancelProductionDrawer(false);
  };
  const showCancelProduction = (id) => {
    setSelectedParentReel(id);
    setViewCancelProductionDrawer(true);
  };

  const onCloseParentReelCancel = (id) => {
    setViewParentReelJobCardDrawer(false);
    showCancelProduction(id);
  };

  const onCloseCancelBack = (id) => {
    showParentReelJobCard(id);
    setViewCancelProductionDrawer(false);
  };

  const showViewDrawer = (value,record) => {
    setSelectedOrderNo(value);
    setSelectedOrder(record)
    setViewOrder(true);
  };

  const closeViewDrawer = () => {
    setViewOrder(false);
  };

  const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item?.slice(1);

  const jobcardState = (state) => {
    switch (state) {
      case "pending":
        return "Pending for approval";
      case "approved":
        return "Approved";
      case "hold":
        return "On Hold";
      case "in_production":
        return "In Production";
      case "complete":
        return "Complete";
      case "cancel":
        return "Production Cancelled";
      default:
        return;
    }
  };

  const getJobCardDetailsById = async () => {
    try {
      const response = await getProductionJobCardsByIdMultistage(jobId);
      setJobCard(response);
      const selectedState =
        response.state === "complete" ||
        response.state === "in_production" ||
        response.state === "hold" ||
        response.state === "cancel";
      setIsValidState(response.state === "in_production");
      if (response.jobcard.solution_1.status === "accept") {
        setAcceptedSolution({
          name: "Solution 1",
          key: 1,
          solution: response.jobcard.solution_1,
        });
        setIsParentReelCancelled(
          response.jobcard.solution_1.data.parent_reel_cancelled &&
            selectedState
        );
        // setSizeFulfillmentDetails(response.jobcard.solution_1.data.sizes);
      } else if (response.jobcard.solution_2.status === "accept") {
        setAcceptedSolution({
          name: "Solution 2",
          key: 2,
          solution: response.jobcard.solution_2,
        });
        setIsParentReelCancelled(
          response.jobcard.solution_2.data.parent_reel_cancelled &&
            selectedState
        );
        // setSizeFulfillmentDetails(response.jobcard.solution_2.data.sizes);
      }
    } catch (error) {
      console.log(error.response);
    }
  };
  useEffect(() => {
    const tempDiaArray = [];
    // console.log(acceptedSolution);
    acceptedSolution?.solution?.data?.orders?.map((order) => {
      // console.log(order);
      tempDiaArray.push(order?.diameter_fulfillment);
    });
    setDiameterFulfilmentArray(tempDiaArray);
    // console.log(tempDiaArray);
    // console.log("acc", acceptedSolution);
    acceptedSolution?.solution?.data?.sizes.length &&
      setSizeFulfillmentDetails(acceptedSolution?.solution?.data, tempDiaArray);
  }, [acceptedSolution]);
  const setSizeFulfillmentDetails = (data, diameterFulfilmentArray1) => {
    const sizes = data.sizes;
    let sizeFulfillmentList = sizes?.map((size, index) => {
      // console.log(index);

      // console.log("SDWJSKFJ", diameterFulfilmentArray1);
      
      return {
        key: index + 1,
        type: "Order",
        size: `${size.size} ${
          size.lateral_size ? "X " + size.lateral_size : ""
        } ${" "} ${
          size.units && size.units.size
            ? lengthUnit[size.units.size]?.displayName?.toUpperCase()
            : "CM"
        }`,
        plannedReels: size.fulfilled + size.unfulfilled,
        plannedWeight:
          (size.fulfilled_weight + size.unfulfilled_weight)?.toFixed(3) +
          " " +
          (size?.units && size?.units?.fulfilled_weight
            ? capitalize(weightUnit[size.units.fulfilled_weight]?.displayName)
            : "T"),
        fulflilledReels: size.fulfilled,
        grain: size?.grain ? size.grain : '-',
        fulflilledWeight:
          size.fulfilled_weight?.toFixed(3) +
          " " +
          (size?.units && size?.units?.fulfilled_weight
            ? capitalize(weightUnit[size.units.fulfilled_weight]?.displayName)
            : "T"),
        unFulflilledReels: size.unfulfilled,
        unFulflilledWeight:
          size.unfulfilled_weight?.toFixed(3) +
          " " +
          (size?.units && size?.units?.unfulfilled_weight
            ? capitalize(weightUnit[
                size.units.unfulfilled_weight
              ]?.displayName)
            : "T"),
        reelSpecification: size?.diameter_fulfillment.map((diaItem) => {
          const reelOd = diaItem.reel_od;
          const coreId = diaItem.core_id;
          const fulfilledWeight = diaItem.fulfilled_weight?.toFixed(3);
          const fulfilledValue = diaItem.fulfilled;
          const fulfilledWeightUnit = size?.units
            ?.fulfilled_weight
            ? capitalize(
              size.units?.fulfilled_weight? weightUnit[size?.units?.fulfilled_weight].displayName : 't'
              )
            : "";
          return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R)\n`;
        }),
      };
    });

    setSizeFulfillmentDetailsList(sizeFulfillmentList);
  };
  useEffect(() => {
    if (!acceptedSolution) return;
    const ordersList = acceptedSolution?.solution?.data?.orders
      ?.filter((order) => {
        return order.item_type == "order";
      })
      .map((item) => item.order_id);
      ordersList && getIntermediateListItems(
      ordersList,
      jobId,
      acceptedSolution?.key === 1 ? "solution_1" : "solution_2"
    );
  }, [acceptedSolution])
  
  const toggleFetchingData = (isFetching) => {
    console.log(isFetching);
    setIsFetchingDataForCylinder(isFetching)
  }
  useEffect(() => {
    console.log(isFetchingDataForCylinder);
  },[isFetchingDataForCylinder])

  const fetchOrders = async () => {
    setIsFetchingData(true);
    let orderList = [];
    const ordersList = acceptedSolution.solution.data.orders
      ?.filter((order) => {
        return order.item_type == "order";
      })
      ?.map((item) => item.order_id);
      const fulfilledOrdersList = acceptedSolution.solution.data.orders
          ?.filter((order) => {
            return order.item_type == "order" && order.fulfilled_weight > 0;
          })
          ?.map((item) => item.order_id)
  
    const unfulfilledOrdersList = acceptedSolution.solution.data.orders
          ?.filter((order) => {
            return order.item_type == "order" && order.unfulfilled_weight > 0;
          })
          ?.map((item) => item.order_id)
    
    setTotalFulfilledOrders(fulfilledOrdersList.length);
    setTotalUnfulfilledOrders(unfulfilledOrdersList.length);
    // console.log(tota)
    // if()
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    ordersList &&
      getOrdersList([
        ...fulfilledOrdersList.slice(startIndex, endIndex),
        ...unfulfilledOrdersList.slice(startIndex, endIndex),
      ])
        .then((response) => {
          orderList = response.data?.map((item, index) => {
            // console.log("aacccceeppttt", acceptedSolution);
            const orderData = acceptedSolution?.solution?.data?.orders?.filter(
              (order) => parseFloat(order.order_id) === item.number
            )[0];
            // console.log("orderr", orderData);
            let unitValue = orderData.units ? orderData.units : {};
            
            unitValue['fulfilled_weight'] = unitValue?.fulfilled_weight ? unitValue?.fulfilled_weight : unitData.units_management.weight.default;
   
            return {
              key: index + 1,
              pono: `${item.po}`,
              sono:`${item.so}`,
              category:item.category,
              orderno: `${item.number}`,
              type: "Order",
              customercode: item.customer,
              customername: item.customer_name,
              customer_alias: item.customer_alias,
              consignee: item.consignee_name,
              productspec: item.product_spec,
              size: `${item.width}${item.length ? ` x ${item.length}` : ""
                } ${" "} ${item?.units && item?.units?.width
                  ? lengthUnit[item.units.width]?.displayName?.toUpperCase()
                  : "CM"
                }`,
              productInfo: item.product_info,
              plannedReels: orderData.requirement,
              plannedWeight:
                orderData.requirement?.toFixed(3) +
                " " +
                (orderData?.units && orderData.units.requirement
                  ? weightUnit[
                    orderData.units.requirement
                  ]?.displayName.toUpperCase()
                  : "T"),
              fulflilledReels: orderData.fulfilled,
              fulflilledWeight:
                orderData.fulfilled_weight?.toFixed(3) +
                " " +
                (orderData?.units && orderData?.units?.fulfilled_weight
                  ? weightUnit[
                    orderData.units.fulfilled_weight
                  ]?.displayName.toUpperCase()
                  : "T"),
              unFulflilledReels: orderData.unfulfilled,
              unFulflilledWeight:
                orderData.unfulfilled_weight?.toFixed(3) +
                " " +
                (orderData?.units && orderData?.units?.unfulfilled_weight
                  ? weightUnit[
                    orderData.units.unfulfilled_weight
                  ]?.displayName.toUpperCase()
                  : "T"),
              priority: item.forced,
              deliverydate: item.category==='so'?"-": moment(item.delivery_date).format("DD MMM YYYY"),
              remarks: item.remarks,
              reel_od: item.reel_od,
              core_id: item.core_id,
              consignee_name: item.consignee_name,
              consignee_code: item.consignee_code,
              plannedreel: "d",
              reelSpecification: orderData?.diameter_fulfillment?.map(
                (diaItem) => {
                  const reelOd = diaItem.reel_od;
                  const coreId = diaItem.core_id;
                  const fulfilledWeight = diaItem.fulfilled_weight?.toFixed(3);
                  const fulfilledValue = diaItem.fulfilled;
                  const fulfilledWeightUnit = capitalize(
                    orderData.units?.fulfilled_weight ? weightUnit[orderData.units?.fulfilled_weight].displayName : 'T'
                  );
                  return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R)\n`;
                }
              ),
              cancelledQty: orderData?.cancelled_diameter_fulfillment?.map((diaItem) => {
                const reelOd = diaItem.reel_od;
                const coreId = diaItem.core_id;
                const fulfilledWeight =
                  diaItem.fulfilled_weight?.toFixed(3);
                const fulfilledValue = diaItem.fulfilled;
                const fulfilledWeightUnit = capitalize(
                  orderData.units?.fulfilled_weight ? weightUnit[orderData.units?.fulfilled_weight].displayName : 'T'
                );
                return (fulfilledWeight && fulfilledValue) ? `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R) \n` : '-';
              }),
              diameter_fulfillment: orderData?.diameter_fulfillment?.map(
                (diaItem, index) => {
                  return {
                    reel_od: diaItem.reel_od,
                    core_id: diaItem.core_id,
                    fulfilled_weight: diaItem.fulfilled_weight - orderData?.cancelled_diameter_fulfillment[index].fulfilled_weight,
                    fulfilled: diaItem.fulfilled - orderData?.cancelled_diameter_fulfillment[index].fulfilled,
                    fulfilledWeightUnit:
                      orderData.units?.fulfilled_weight ? orderData.units?.fulfilled_weight : unitData.units_management.weight.default

                  }
                  
                }
              ),
              cancelled_diameter_fulfillment: orderData?.cancelled_diameter_fulfillment,
              fulfilled_quantity: orderData.fulfilled_weight - orderData.cancelled_weight,
              units: unitValue,
              matchedGrain: orderData?.grain,
              isReel : orderData.type === 'reel',
            };
          });

          const stockSizesList = acceptedSolution.solution.data.orders
            ?.filter((order) => {
              return order.item_type == "stock";
            })
            ?.map((item) => item.order_id);
          if (stockSizesList.length > 0) {
            getStocksDetailsByIds({ stocks: stockSizesList })
              .then((response) => {
                let sizesList = response.data?.map((item, index) => {
                  const orderData =
                    acceptedSolution.solution.data.orders.filter(
                      (order) => order.order_id === item.id
                    )[0];
                  let unitValue = orderData.units ? orderData.units : {};
                  unitValue['fulfilled_weight'] = unitValue?.fulfilled_weight ? unitValue?.fulfilled_weight : unitData.units_management.weight.default;
           
                  return {
                    key: index + 1,
                    pono: "-",
                    orderno: `${item.id}`,
                    type: "Stock",
                    customercode: "-",
                    customername: "-",
                    customer_alias: "-",
                    size: `${item.width}${item.length ? ` x ${item.length}` : ""
                      } ${" "} ${item.units && item.units?.width
                        ? lengthUnit[
                          item.units.width
                        ]?.displayName?.toUpperCase()
                        : "CM"
                      }`,
                    productInfo: item.product_info,
                    plannedReels: "-",
                    plannedWeight: "-",
                    fulflilledReels: orderData.fulfilled,
                    fulflilledWeight:
                      orderData.fulfilled_weight?.toFixed(3) +
                      " " +
                      (orderData?.units && orderData.units.fulfilled_weight
                        ? weightUnit[
                          orderData.units.fulfilled_weight
                        ]?.displayName.toUpperCase()
                        : "T"),
                    unFulflilledReels: "-",
                    unFulflilledWeight: "-",
                    priority: false,
                    deliverydate: "-",
                    remarks: "",
                    reel_od: item.reel_od,
                    core_id: item.core_id,
                    plannedreel: "ss",
                    reelSpecification: orderData?.diameter_fulfillment?.map(
                      (diaItem) => {
                        const reelOd = diaItem.reel_od;
                        const coreId = diaItem.core_id;
                        const fulfilledWeight =
                          diaItem.fulfilled_weight?.toFixed(3);
                        const fulfilledValue = diaItem.fulfilled;
                        const fulfilledWeightUnit = capitalize(
                          weightUnit[orderData.units?.fulfilled_weight]
                            ?.displayName
                        );
                        return `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R)\n`;
                      }
                    ),
                    diameter_fulfillment: orderData?.diameter_fulfillment?.map(
                      (diaItem, index) => {
                        return {
                          reel_od: diaItem.reel_od,
                          core_id: diaItem.core_id,
                          fulfilled_weight: diaItem.fulfilled_weight - orderData?.cancelled_diameter_fulfillment[index].fulfilled_weight,
                          fulfilled: diaItem.fulfilled - orderData?.cancelled_diameter_fulfillment[index].fulfilled,
                          fulfilledWeightUnit: orderData.units?.fulfilled_weight ? orderData.units?.fulfilled_weight : unitData.units_management.weight.default

                        }
                        
                      }
                    ),
                    cancelled_diameter_fulfillment: orderData?.cancelled_diameter_fulfillment,
                    fulfilled_quantity: orderData.fulfilled_weight - orderData.cancelled_weight,
                    units: unitValue,
                    cancelledQty: orderData?.cancelled_diameter_fulfillment?.map((diaItem) => {
                      const reelOd = diaItem.reel_od;
                      const coreId = diaItem.core_id;
                      const fulfilledWeight =
                        diaItem.fulfilled_weight?.toFixed(3);
                      const fulfilledValue = diaItem.fulfilled;
                      const fulfilledWeightUnit = capitalize(
                        weightUnit[orderData.units?.fulfilled_weight]?.displayName
                      );
                      return (fulfilledWeight && fulfilledValue) ? `${reelOd} / ${coreId} (${fulfilledWeight} ${fulfilledWeightUnit}, ${fulfilledValue}R) \n` : '-';
                    }),
                  };

                });
                // console.log(orderList);

                setOrderDetailsList([...orderList, ...sizesList]);
              })
              .catch((error) => console.log(error));
          } else {
            setOrderDetailsList(orderList);
          }
        })
        .catch((error) => console.log(error))
        .finally(() => { setIsFetchingData(false) });
  };

  useEffect(async () => {
    try {
      const unitData = await getUnitData();
      if (!unitData.error) {
        setUnitData(unitData.data);
      }
    } catch (err) {
      console.log(err);
    }
    if (location.state) setSearchParams({ id: location.state.id });
  }, []);

  useEffect(() => {
    if (reFetch) {
      getJobCardDetailsById();
      setReFetch(false);
    }
  }, [reFetch]);

  useEffect(() => {
    // console.log(jobCard?.state)
    if (
      (jobCard?.state === "in_production" || jobCard?.state === "complete") &&
      reFetchJumboReels
    ) {
      setIsMapJumboLoading(true);
      getJumboReelDetailsById(jobId)
        .then((response) => {
          let isCancelDisabled = false;
          let holdProductionCounter = 0;

          setJumboReelData(
            response.data.data?.map((item) => {
              if (item.status === "produced") setProducedParentReelBool(true);
              if (item.status === "mapped" || item.status === "produced") {
                setDisableCancel(true);
                isCancelDisabled = true;
              }

              const reelOdValue = item.reel_od
                ? `${item.reel_od} ${jobCard.jobcard.group.grouping_params.units &&
                  jobCard.jobcard.group.grouping_params.units.reel_od
                  ? lengthUnit[
                    jobCard.jobcard.group.grouping_params.units.reel_od
                  ]?.displayName.toUpperCase()
                  : "CM"
                }`
                : "0"; // If item.reel_od doesn't exist, set the value to "0"
              const coreIdValue = item.core_id
                ? `${item.core_id} ${jobCard.jobcard.group.grouping_params.units &&
                  jobCard.jobcard.group.grouping_params.units.core_id
                  ? lengthUnit[
                    jobCard.jobcard.group.grouping_params.units.core_id
                  ]?.displayName.toUpperCase()
                  : "CM"
                }`
                : "0";
              // console.log(item.status)
              if (item.status !== 'cancel' && item.status !== 'produced') holdProductionCounter++;
              // console.log(holdProductionCounter)
              return {
                leftTrim: item.left_edge_trim,
                rightTrim: item.right_edge_trim,
                deckleWidth: item.deckle_width,
                priority: item.priority,
                parentReel: item.parent_reel.id,
                combinations: item.combinations,
                comWidth: item.d_com_width,
                trimLoss: item.trim_loss,
                netTrimLoss: item.net_trim_loss,
                deliverydate: item.earliest_delivery_date,
                mappedJumboRoll: item?.mapped_jumbo_reels,
                status:
                  item.status === "open"
                    ? "Not Mapped"
                    : item.status === "cancel"
                      ? "Cancelled"
                      : capitalize(item.status),
                core_id: item.core_id,
                reel_od: item.reel_od,
                machine_type: item.machine_type,
                chop_size: item.combinations[0]?.length
                  ? item.combinations[0]?.length
                  : "",
                units: item.units,
                diaValue: `${reelOdValue} / ${coreIdValue}`,
                combination_no: item.combination_no,
              };
            })
          );
          // console.log(holdProductionCounter)
          if (!holdProductionCounter) setDisableHoldProduction(true);
          if (!isCancelDisabled) setDisableCancel(false);
        })
        .catch((error) => {
          // console.log(error.response.data.msg)
          if (error.response.data.msg === "only in production jobcards are required") {
            setReFetch(true);
            setActiveTab("1")
          }
        }).finally(() => setIsMapJumboLoading(false));
      setReFetchJumboReels(false);
    }
    if(jobCard && isDrawerOpened){
      setActiveTab("2");
      if(type == "add" || type == "edit"){
        setViewMapToReelDrawer(true);
      } else{
        setViewCloseProductionDrawer(true);
      }
      // setDrawerOpen(false);
      // setType(location?.state?.typ);
    }
  }, [jobCard, reFetchJumboReels]);

  useEffect(() => {
    if (acceptedSolution.solution) fetchOrders();
  }, [acceptedSolution, pageSize, currentPage]);
  useEffect(() => {
    if (acceptedSolution.solution) fetchOrdersForPrint();
  },[acceptedSolution])
  useEffect(() => {
    for (let i = 0; i < jumboReelData?.length; i++) {
      if (jumboReelData[i].status !== "Cancel")
        if (jumboReelData[i].status === "Mapped") setDisablePrint(false);
        else {
          setDisablePrint(true);
          break;
        }
    }
    return () => {};
  }, [jumboReelData]);

  return jobCard && acceptedSolution.solution ? (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg" style={{ borderBottom: "0px" }}>
        <PageHeader
          ghost={false}
          onBack={() => navigate("../production-job-cards")}
          title="Job Card Details"
          extra={
            jobCard.state === "approved"
              ? [
                  <Button
                    key="1"
                    className="themeBtn"
                    onClick={showModal}
                    disabled={!userDetails.roles.production.job_cards.edit}
                    loading={loadings}
                  >
                    {!loadings && (
                      <Iconmoon icon="correct-file" size={14} color="#fff" />
                    )}
                    {!loadings ? "Move to Production" : ""}
                  </Button>,
                ]
              : jobCard.state === "in_production"
              ? [
                  <Button
                    key="1"
                    className={`themeBtn noBg ${
                      disableCancel ? "disabled" : ""
                    }`}
                    loading={isCancelLoading}
                    onClick={showCancelJobCardDrawer}
                    disabled={
                      !userDetails.roles.production.job_cards.edit ||
                      disableCancel
                    }
                  >
                  {!isCancelLoading &&
                    <Iconmoon
                      icon="wrong"
                      size={14}
                      color={disableCancel ? "#A19F9D" : "#EA655B"}
                    />
                  }
                        Cancel Production
                  </Button>,
                  <Button
                    key="2"
                    className="themeBtn noBg"
                    onClick={holdModalShow}
                    loading={isHoldLoading}
                    disabled={!userDetails.roles.production.job_cards.edit || disableHoldPoduction}
                  >
                   {!isHoldLoading && <Iconmoon icon="wrong-file" size={14} color="#EA655B" />}
                    Hold Production
                  </Button>,
                  <Button
                    key="3"
                    className="themeBtn"
                    onClick={completeProduction}
                    disabled={
                      !userDetails.roles.production.job_cards.edit ||
                      !producedParentReelBool
                    }
                  >
                    <Iconmoon icon="correct" size={14} color="#fff" />
                    Complete Production
                  </Button>,
                ]
              : jobCard.state === "hold"
              ? [
                  <Button
                    key="1"
                    className="themeBtn"
                    onClick={resumeProduction}
                    disabled={!userDetails.roles.production.job_cards.edit}
                  >
                    <Iconmoon icon="correct-file" size={14} color="#fff" />
                    Resume Production
                  </Button>,
                ]
              : []
          }
        ></PageHeader>
      </PageTitleComp>
      <ResultWrap>
        <DetailFields
          className="jobCardView"
          style={{ justifyContent: "flex-start" }}
        >
          <SolutionContainer>
          <PageTitleComp style={{ borderBottom: "0" }}>
            <PageHeader
              ghost={false}
              title={`Job Card ${jobCard.id}`}
              className="jobCardList-Grid"
              // extra={[
              //   ,
              // ]}
            ></PageHeader>

            <div
              className={`jobCardList ${"fullWidth"}`}
              style={{
                alignSelf: "center",
                display: "flex",
                marginTop: isParentReelCancelled && (activeTab>=3) ? '20px' : '34px',
                // alignContent:'top'
              }}
            >
              <JobCardColorStatus>
                <div className="statusVal" dataval={jobCard.state}>
                  {jobcardState(jobCard.state)}
                </div>
              </JobCardColorStatus>

              {activeTab != 2 && orderDetailsList && (
                <TableList
                  style={{
                    justifyContent: "flex-end",
                    display: "flex",
                  }}
                >
                  {/*
                  <div className="List-grid-View" onClick={printJobCardDetails}>
                    <div className="printIcon">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.8334 6.66667H4.16669C2.78335 6.66667 1.66669 7.78334 1.66669 9.16667V14.1667H5.00002V17.5H15V14.1667H18.3334V9.16667C18.3334 7.78334 17.2167 6.66667 15.8334 6.66667ZM13.3334 15.8333H6.66669V11.6667H13.3334V15.8333ZM15.8334 10C15.375 10 15 9.62501 15 9.16667C15 8.70834 15.375 8.33334 15.8334 8.33334C16.2917 8.33334 16.6667 8.70834 16.6667 9.16667C16.6667 9.62501 16.2917 10 15.8334 10ZM15 2.50001H5.00002V5.83334H15V2.50001Z"
                          fill="#605E5C"
                        />
                      </svg>
                    </div>
                  </div>
                  */}
                </TableList>
              )}
            </div>
            
            {activeTab == 2 && (
              <Button
                key="1"
                className={`noBgBtn ${
                  jobCard.state === "hold" || disablePrint ? "disabled" : ""
                }`}
                //disabled={jobCard.state === "hold" || disablePrint}
                // onClick={() => routeChange(record)}
                onClick={() => printJobCard(jobCard)}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.8334 6.66667H4.16669C2.78335 6.66667 1.66669 7.78334 1.66669 9.16667V14.1667H5.00002V17.5H15V14.1667H18.3334V9.16667C18.3334 7.78334 17.2167 6.66667 15.8334 6.66667ZM13.3334 15.8333H6.66669V11.6667H13.3334V15.8333ZM15.8334 10C15.375 10 15 9.62501 15 9.16667C15 8.70834 15.375 8.33334 15.8334 8.33334C16.2917 8.33334 16.6667 8.70834 16.6667 9.16667C16.6667 9.62501 16.2917 10 15.8334 10ZM15 2.50001H5.00002V5.83334H15V2.50001Z"
                    fill={
                      jobCard.state === "hold" || disablePrint
                        ? "#A19F9D"
                        : "#EA655B"
                    }
                  />
                </svg>
                Print Job Card
              </Button>
            )}
             {isParentReelCancelled && (activeTab>=3) && <Col span={9} style={{display:'absolute'}}>
              <div className="cancelledSetMessage" style={{ display:'flex', marginTop:'25px', borderRadius:"4px", backgroundColor: '#f4f0ec', padding:'4px 6px', opacity:0.95}}>
                <div style={{padding:'10px 6px 2px 3px'}}><Iconmoon icon='warning_new' size={20} style={{ color: '#808080' }} /></div>
                <span style={{ fontSize: '14px', color:'#555555'}}>A few sets were cancelled in this job card. Hence, fulfilled
                quantity might not be accurate for the cancelled sets.</span>
              </div>
            </Col> }
          </PageTitleComp>
          <div className="MatchResult JobResulted ProdResult">
            <Row span={24}>
              {activeTab != 2 && (
                <Col
                  span={15}
                  className="pipeBlock"
                  style={{ paddingRight: "20px", transform: isParentReelCancelled && (activeTab >= 3) ? 'translateY(-14px)' : '' }}
                >
                   <>
                    <TableList>
                      <div className="radioSwitchStyle" style={{ zIndex: 10 }}>
                        <div className="table-view">
                          <HaberForm>
                            <RadioButtonStyle>
                              <div
                                className="boxFormType switchRadio"
                                style={{
                                  justifyContent: "flex-end",
                                  display: "flex",
                                  // paddingRight: "",
                                  transform: "translate(-225px,-15px)",
                                  position: "absolute",
                                  width: "200px",
                                }}
                              >
                                <Radio.Group
                                  options={filterViewData}
                                  onChange={handleViewChange}
                                  value={
                                    isJobcardView && isSheetView
                                      ? "both"
                                      : isJobcardView
                                      ? "reel"
                                      : "sheet"
                                  }
                                  optionType="button"
                                  buttonStyle="solid"
                                  className={
                                    isSheetView && isJobcardView
                                      ? "allActive"
                                      : isSheetView
                                      ? "sheetActive"
                                      : "jcActive"
                                  }
                                />
                              </div>
                            </RadioButtonStyle>
                          </HaberForm>
                        </div>
                        <div className="table-view">
                          <HaberForm>
                            <RadioButtonStyle>
                              <div
                                className="boxFormType switchRadio"
                                style={{
                                  justifyContent: "flex-end",
                                  display: "flex",
                                }}
                              >
                                <Radio.Group
                                  options={gridViewData}
                                  onChange={handleViewChangeGrid}
                                  value={isTabularView}
                                  optionType="button"
                                  buttonStyle="solid"
                                  className={
                                    !isTabularView
                                      ? "gridViewActive"
                                      : "ListViewActive"
                                  }
                                />
                              </div>
                            </RadioButtonStyle>
                          </HaberForm>
                        </div>
                      </div>
                    </TableList>

                    <div
                      style={{
                        display: isJobcardView ? "block" : "none",
                        padding: "0px",
                          margin: "0px",
                          transform:"translateY(-20px)"
                      }}
                    >
                      <JobCardCylinderContainerMultistage
                        jobId={jobId}
                        solution={acceptedSolution.key}
                        multiView={false}
                        print_function={
                          orderDetailsList ? printJobCardDetails : null
                        }
                        collapse={props.collapse}
                        isPrintDisabled={isPrintDisabled}
                        toggleFetchingData= {toggleFetchingData}
                        // style={{width:'80%'}}
                        deckleSize={`${
                          jobCard?.jobcard?.group.machines?.find(
                            (item) => item.machine_type !== "cutter"
                          )?.deckle_size_lb || ""
                        } - ${
                          jobCard?.jobcard?.group.machines?.find(
                            (item) => item.machine_type !== "cutter"
                          )?.deckle_size_ub || ""
                        } ${
                          jobCard?.jobcard?.group.machines?.find(
                            (item) => item.machine_type !== "cutter"
                          )?.units?.deckle_size_lb
                            ? lengthUnit[
                                jobCard?.jobcard?.group.machines?.find(
                                  (item) => item.machine_type !== "cutter"
                                )?.units?.deckle_size_lb
                              ]?.displayName
                            : "cm"
                        }`}
            
                        rewinderName={`${
                          jobCard?.jobcard?.group.machines?.find(
                            (item) => item.machine_type !== "cutter"
                          )?.rewinder_name
                        }`}
                        solId={acceptedSolution.key}
                        isTabularView={isTabularView}
                        isValidState={isValidState}
                        cancelSetToggle={() => setIsSetCancelled(!isSetCancelled)}
                        reFetch={reFetch}
                      />
                    </div>

                    {isSheetView && (
                      <SheetJobCardCylinderContainerMultistage
                        jobId={jobId}
                        solution={acceptedSolution.key}
                        multiView={false}
                        acceptedSolution={acceptedSolution?.solution}
                        jobCard={jobCard.jobcard}
                        print_function={
                          orderDetailsList ? printJobCardDetails : null
                        }
                          unitData={unitData}
                          isValidState={isValidState}
                          isTabularView={isTabularView}
                          reFetchToggle={() => {
                            setReFetch(true);
                            console.log("inmper");
                          }}
                      />
                    )}
                  </>
                </Col>
              )}
              <Col
                span={activeTab == 2 ? 24 : 9}
                className="colLayoutBlock leftPostTab"
              >
                <Tabs
                  defaultActiveKey={activeTab}
                  activeKey={activeTab}
                  className="topPostTab innerPostTab"
                  onChange={tabChange}
                >
                  <Panes tab="Job Card Summary" key="1">
                    <div className="lossValue">
                      <Row span={24} style={{ paddingTop: "10px" }}>
                        <Col span={12}>
                          <div
                            className={
                              isParentReelCancelled
                                ? "summaryValueCancelled"
                                : "summaryValue"
                            }
                          >
                            <h5>
                              <span className="trimCut"></span> Trim Loss
                            </h5>
                            <span>
                              {acceptedSolution?.solution
                                ? acceptedSolution.solution.data.summary.match_trim_loss_percentage.toFixed(
                                    3
                                  )
                                : ""}{" "}
                              %
                            </span>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div
                            className={
                              isParentReelCancelled
                                ? "summaryValueCancelled"
                                : "summaryValue"
                            }
                          >
                            <h5>
                              <span className="trimBox"></span> Fulfilment
                            </h5>
                            <span>
                              {acceptedSolution && acceptedSolution.solution
                                ? acceptedSolution.solution?.data.summary?.weight_requirement_fulfilled_percentage.toFixed(
                                    3
                                  )
                                : ""}
                            {' '}  %
                            </span>
                          </div>
                        </Col>
                      </Row>
                      <Row span={24}>
                        <Col span={12}>
                          <div
                            className={
                              isParentReelCancelled
                                ? "summaryValueCancelled"
                                : "summaryValue"
                            }
                          >
                            <h5>
                              <span className="trimCut"></span> Net Trim Loss:{" "}
                              {acceptedSolution.solution?.data.summary?.net_trim_loss_percentage.toFixed(
                                3
                              )}
                             {' '} %<p>Loss including edge trim</p>
                            </h5>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div
                            className={
                              isParentReelCancelled
                                ? "summaryValueCancelled"
                                : "summaryValue"
                            }
                          >
                            <h5>
                              <span className="trimBox"></span> Weight:{" "}
                              {acceptedSolution.solution?.data.summary?.job_card_weight.toFixed(
                                3
                              )}{" "}
                              {acceptedSolution.solution?.data.summary.units &&
                              acceptedSolution.solution?.data.summary.units
                                .job_card_weight
                                ? capitalize(
                                    weightUnit[
                                      acceptedSolution.solution?.data.summary
                                        .units.job_card_weight
                                    ]?.displayName
                                  )
                                : "T"}
                              <p className="lesserSolution">
                                Total weight of Job Card
                              </p>
                            </h5>
                          </div>
                        </Col>
                      </Row>

                      {isParentReelCancelled && (
                        <>
                          <Row span={24} style={{ paddingTop: "10px" }}>
                            <Col span={12}>
                              <div className={"summaryValue"}>
                                <h5>
                                  <span className="trimCut"></span>Updated Trim
                                  Loss
                                </h5>
                                <span>
                                  {acceptedSolution?.solution
                                    ? acceptedSolution.solution.data.summary.new_match_trim_loss_percentage?.toFixed(
                                        3
                                      )
                                    : ""}{" "}
                                  %
                                </span>
                              </div>
                            </Col>
                            <Col span={12}>
                              <div className={"summaryValue"}>
                              <h5>
                                <span className="trimBox"></span>Updated Fulfilment
                              </h5>
                              <span>
                                {acceptedSolution && acceptedSolution.solution
                                  ? acceptedSolution.solution?.data.summary?.new_weight_requirement_fulfilled_percentage.toFixed(
                                      3
                                    )
                                  : ""}{" "}  
                                %
                              </span>
                              </div>
                            </Col>
                          </Row>

                          <Row span={24}>
                            <Col span={12}>
                              <div className={"summaryValue"}>
                                <h5>
                                  <span className="trimCut"></span>Updated Net
                                  Trim Loss:{" "}
                                  {acceptedSolution.solution?.data.summary?.new_net_trim_loss_percentage?.toFixed(
                                    3
                                  )}
                                  {' '} %<p>Loss including edge trim</p>
                                </h5>
                              </div>
                            </Col>
                            <Col span={12}>
                              <div className={"summaryValue"}>
                                <h5>
                                  <span className="trimBox"></span>Updated
                                  Weight:{" "}
                                  {acceptedSolution.solution?.data.summary?.new_job_card_weight?.toFixed(
                                    3
                                  )}{" "}
                                  {acceptedSolution.solution?.data.summary
                                    .units &&
                                  acceptedSolution.solution?.data.summary.units
                                    .job_card_weight
                                    ? capitalize(
                                        weightUnit[
                                          acceptedSolution.solution?.data
                                            .summary.units.job_card_weight
                                        ]?.displayName
                                      )
                                    : "T"}
                                  <p className="lesserSolution">
                                    Total weight of Job Card
                                  </p>
                                </h5>
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}
                      <Collapse
                          className="sub-category"
                          expandIconPosition="right"
                          defaultActiveKey={["1", "2", "3", "4"]}
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <CollapsePanel key="1" header="General Information">
                            <Row
                              span={24}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Col span={11}>
                                {" "}
                                <span>Product Specifications</span>
                                <p
                                  style={{
                                    wordWrap: "break-word",
                                  }}
                                >
                                  {jobCard?.jobcard.product.product_spec}
                                </p>
                              </Col>
                              <Col span={11}>
                                <span>Priority Quantity</span>
                                <p>
                                  {jobCard?.jobcard[
                                    `solution_${acceptedSolution.key}`
                                  ].data.summary?.forced_weight_requirement
                                    ? jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary.forced_weight_requirement.toFixed(
                                        3
                                      )
                                    : 0}{" "}
                                  {jobCard?.jobcard[
                                    `solution_${acceptedSolution.key}`
                                  ].data.summary?.units
                                    ?.forced_weight_requirement
                                    ? capitalize(
                                        weightUnit[
                                          jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary?.units
                                            .forced_weight_requirement
                                        ]?.displayName
                                      )
                                    : "T"}
                                </p>
                              </Col>
                            </Row>
                          </CollapsePanel>

                          <CollapsePanel key="2" header="Paper Machine">
                            <Row
                              span={24}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              {" "}
                              <Col span={11}>
                                <span>Paper Machine</span>
                                <p>{jobCard?.jobcard.group.machines[0].name}</p>
                              </Col>
                              <Col span={11}>
                                <span>Deckle Width</span>
                                <p>{calculateDeckleSize(jobCard)}</p>
                              </Col>{" "}
                            </Row>{" "}
                          </CollapsePanel>
                          {isParentReelCancelled ? <>
                            <CollapsePanel key="3" header="Rewinding">
                            <Row
                              span={24}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "10px 0px",
                              }}
                            >
                              {" "}
                              <Col span={11}>
                                  <span className="updatedText" style={{display:'flex', gap:'5px', alignItems:"center"}}>
                                    Updated Rewinding Qty
                                    <Styled>
                                      <Tooltip
                                        placement="bottom"
                                        title={`This is the updated quantity that needs to be processed on the rewinder after a few sets were cancelled`}
                                        className="edit-tooltip"
                                      >
                                          <Iconmoon
                                            icon="info_new"
                                            size={14}
                                            color="black"
                                            style={{
                                              // opacity: 0.7,
                                              // marginTop: "2px",
                                              float: "right",
                                            }}
                                          />
                                      </Tooltip>
                                    </Styled>
                                  </span>{" "}
                                <p>
                                  {jobCard?.jobcard[
                                    `solution_${acceptedSolution.key}`
                                  ].data.summary?.new_net_rewinding_quantity
                                    ? jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary.new_net_rewinding_quantity.toFixed(
                                        3
                                      )
                                    : 0}{" "}
                                  {jobCard?.jobcard[
                                    `solution_${acceptedSolution.key}`
                                  ].data.summary?.units?.new_net_rewinding_quantity
                                    ? capitalize(
                                        weightUnit[
                                          jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary?.units
                                            .new_net_rewinding_quantity
                                        ]?.displayName
                                      )
                                    : "T"}
                                </p>
                              </Col>
                              <Col span={11}>
                                  <span className="updatedText" style={{display:'flex', gap:'5px', alignItems:"center"}}>
                                    Updated Trim Loss
                                    <Styled>
                                      <Tooltip
                                        placement="bottom"
                                        title={`This is the updated trim loss of rewinding after a few sets were cancelled`}
                                        className="edit-tooltip"
                                      >
                                          <Iconmoon
                                            icon="info_new"
                                            size={14}
                                            color="black"
                                            style={{
                                              // opacity: 0.7,
                                              // marginTop: "2px",
                                              float: "right",
                                            }}
                                          />
                                      </Tooltip>
                                    </Styled>
                                </span>
                                <p>
                                  {jobCard?.jobcard[
                                    `solution_${acceptedSolution.key}`
                                  ].data.summary?.new_rewinding_net_trim_loss
                                    ? jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary.new_rewinding_net_trim_loss.toFixed(
                                        3
                                      )
                                    : 0}{" "}
                                  {jobCard?.jobcard[
                                    `solution_${acceptedSolution.key}`
                                  ].data.summary?.units?.new_rewinding_net_trim_loss
                                    ? capitalize(
                                        weightUnit[
                                          jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary?.units
                                            .new_rewinding_net_trim_loss
                                        ]?.displayName
                                      )
                                    : "T"}
                                </p>
                              </Col>{" "}
                            </Row>{" "}
                            <Row
                              span={24}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "10px 0px",
                              }}
                            >
                              {" "}
                              <Col span={11}>
                                <span>Rewinder</span>{" "}
                                <p>
                                  {
                                    jobCard?.jobcard?.group.machines?.filter(
                                      (item) => item.machine_type === "rewinder"
                                    )[0]?.rewinder_name
                                  }
                                </p>
                              </Col>
                              <Col span={11}>
                                  <span className="updatedText" style={{display:'flex', gap:'5px', alignItems:"center"}}>Updated Processed Order
                                    <Styled>
                                      <Tooltip
                                        placement="bottom"
                                        title={`This is the updated order quantity fulfilled on the rewinder after a few sets were cancelled`}
                                        className="edit-tooltip"
                                      >
                                          <Iconmoon
                                            icon="info_new"
                                            size={14}
                                            color="black"
                                            style={{
                                              // opacity: 0.7,
                                              // marginTop: "2px",
                                              float: "right",
                                            }}
                                          />
                                      </Tooltip>
                                    </Styled></span>
                                <p>
                                  {jobCard?.jobcard[
                                    `solution_${acceptedSolution.key}`
                                  ].data.summary
                                    ?.new_rewinder_processed_order_quantity
                                    ? jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary.new_rewinder_processed_order_quantity.toFixed(
                                        3
                                      )
                                    : 0}{" "}
                                  {jobCard?.jobcard[
                                    `solution_${acceptedSolution.key}`
                                  ].data.summary?.units
                                    ?.new_rewinder_processed_order_quantity
                                    ? capitalize(
                                        weightUnit[
                                          jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary?.units
                                            .new_rewinder_processed_order_quantity
                                        ]?.displayName
                                      )
                                    : "T"}
                                </p>
                              </Col>{" "}
                            </Row>{" "}
                            <Row
                              span={24}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "10px 0px",
                              }}
                            >
                              {" "}
                              <Col span={11}>
                                <span className="updatedText" style={{display:'flex', gap:'5px', alignItems:"center"}}>Updated Unique Sets<Styled>
                                      <Tooltip
                                        placement="bottom"
                                      className="edit-tooltip"
                                      title="This is the updated number of unique sets after a few sets were cancelled"
                                      >
                                          <Iconmoon
                                            icon="info_new"
                                            size={14}
                                            color="black"
                                            style={{
                                              // opacity: 0.7,
                                              // marginTop: "2px",
                                              float: "right",
                                            }}
                                          />
                                      </Tooltip>
                                    </Styled></span>{" "}
                                <p>
                                  {jobCard?.jobcard[
                                    `solution_${acceptedSolution.key}`
                                  ].data.summary?.new_unique_rewinding_partitions
                                    ? jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary.new_unique_rewinding_partitions
                                    : 0}{" "}
                                </p>
                              </Col>
                              <Col span={11}>
                                  <span className="updatedText" style={{display:'flex', gap:'5px', alignItems:"center"}}>
                                    Updated Total Sets
                                    <Styled>
                                      <Tooltip
                                        placement="bottom"
                                        title={`This is the updated number of total sets to be processed on this rewinder after a few sets were cancelled`}
                                        className="edit-tooltip"
                                      >
                                          <Iconmoon
                                            icon="info_new"
                                            size={14}
                                            color="black"
                                            style={{
                                              // opacity: 0.7,
                                              // marginTop: "2px",
                                              float: "right",
                                            }}
                                          />
                                      </Tooltip>
                                    </Styled></span>
                                <p>
                                  {jobCard?.jobcard[
                                    `solution_${acceptedSolution.key}`
                                  ].data.summary?.new_total_rewinding_partitions
                                    ? jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary.new_total_rewinding_partitions
                                    : 0}{" "}
                                </p>
                              </Col>{" "}
                            </Row>{" "}
                          </CollapsePanel>
                          <CollapsePanel key="4" header="Cutting">
                            <Row
                              span={24}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "10px 0px",
                              }}
                            >
                              {" "}
                              <Col span={11}>
                                 <span className="updatedText" style={{display:'flex', gap:'5px', alignItems:"center"}}>Updated Cutting Qty<Styled>
                                      <Tooltip
                                        placement="bottom"
                                        title={`This is the updated quantity that needs to be processed on the cutter after a few sets were cancelled`}
                                        className="edit-tooltip"
                                      >
                                          <Iconmoon
                                            icon="info_new"
                                            size={14}
                                            color="black"
                                            style={{
                                              // opacity: 0.7,
                                              // marginTop: "2px",
                                              float: "right",
                                            }}
                                          />
                                      </Tooltip>
                                    </Styled></span>{" "}
                                <p>
                                  {jobCard?.jobcard[
                                    `solution_${acceptedSolution.key}`
                                  ].data.summary?.new_net_cutting_quantity
                                    ? jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary.new_net_cutting_quantity.toFixed(
                                        3
                                      )
                                    : 0}{" "}
                                  {jobCard?.jobcard[
                                    `solution_${acceptedSolution.key}`
                                  ].data.summary?.units?.new_net_cutting_quantity
                                    ? capitalize(
                                        weightUnit[
                                          jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary?.units
                                            .new_net_cutting_quantity
                                        ]?.displayName
                                      )
                                    : "T"}
                                </p>
                              </Col>
                              <Col span={11}>
                                 <span className="updatedText" style={{display:'flex', gap:'5px', alignItems:"center"}}>Updated Trim Loss<Styled>
                                      <Tooltip
                                        placement="bottom"
                                        title={`This is the updated trim loss of cutting after a few sets were cancelled`}
                                        className="edit-tooltip"
                                      >
                                          <Iconmoon
                                            icon="info_new"
                                            size={14}
                                            color="black"
                                            style={{
                                              // opacity: 0.7,
                                              // marginTop: "2px",
                                              float: "right",
                                            }}
                                          />
                                      </Tooltip>
                                    </Styled></span>
                                <p>
                                  {jobCard?.jobcard[
                                    `solution_${acceptedSolution.key}`
                                  ].data.summary?.new_cutting_net_trim_loss
                                    ? jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary.new_cutting_net_trim_loss.toFixed(
                                        3
                                      )
                                    : 0}{" "}
                                  {jobCard?.jobcard[
                                    `solution_${acceptedSolution.key}`
                                  ].data.summary?.units?.new_cutting_net_trim_loss
                                    ? capitalize(
                                        weightUnit[
                                          jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary?.units
                                            .new_cutting_net_trim_loss
                                        ]?.displayName
                                      )
                                    : "T"}
                                </p>
                              </Col>{" "}
                            </Row>{" "}
                            <Row
                              span={24}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "10px 0px",
                              }}
                            >
                              {" "}
                              <Col span={11}>
                                 <span>Cutter</span>{" "}
                                <p>
                                  {
                                    jobCard?.jobcard?.group.machines?.filter(
                                      (item) => item.machine_type === "cutter"
                                    )[0]?.cutter_name
                                  }
                                </p>
                              </Col>
                              <Col span={11}>
                                 <span className="updatedText" style={{display:'flex', gap:'5px', alignItems:"center"}}>Updated Processed Order<Styled>
                                      <Tooltip
                                        placement="bottom"
                                        title={`This is the updated order quantity fulfilled on the cutter after a few sets were cancelled`}
                                        className="edit-tooltip"
                                      >
                                          <Iconmoon
                                            icon="info_new"
                                            size={14}
                                            color="black"
                                            style={{
                                              // opacity: 0.7,
                                              // marginTop: "2px",
                                              float: "right",
                                            }}
                                          />
                                      </Tooltip>
                                    </Styled></span>
                                <p>
                                  {jobCard?.jobcard[
                                    `solution_${acceptedSolution.key}`
                                  ].data.summary
                                    ?.new_cutting_processed_order_quantity
                                    ? jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary.new_cutting_processed_order_quantity.toFixed(
                                        3
                                      )
                                    : 0}{" "}
                                  {jobCard?.jobcard[
                                    `solution_${acceptedSolution.key}`
                                  ].data.summary?.units
                                    ?.new_cutting_processed_order_quantity
                                    ? capitalize(
                                        weightUnit[
                                          jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary?.units
                                            .new_cutting_processed_order_quantity
                                        ]?.displayName
                                      )
                                    : "T"}
                                </p>
                              </Col>{" "}
                            </Row>{" "}
                            <Row
                              span={24}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "10px 0px",
                              }}
                            >
                              {" "}
                              <Col span={11}>
                                 <span className="updatedText" style={{display:'flex', gap:'5px', alignItems:"center"}}>Updated Unique Sets<Styled>
                                      <Tooltip
                                        placement="bottom"
                                        title={`This is the updated number of unique sets after a few sets were cancelled`}
                                        className="edit-tooltip"
                                      >
                                          <Iconmoon
                                            icon="info_new"
                                            size={14}
                                            color="black"
                                            style={{
                                              // opacity: 0.7,
                                              // marginTop: "2px",
                                              float: "right",
                                            }}
                                          />
                                      </Tooltip>
                                    </Styled></span>{" "}
                                <p>
                                  {jobCard?.jobcard[
                                    `solution_${acceptedSolution.key}`
                                  ].data.summary?.new_unique_cutting_partitions
                                    ? jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary.new_unique_cutting_partitions
                                    : 0}{" "}
                                </p>
                              </Col>
                              <Col span={11}>
                                 <span className="updatedText" style={{display:'flex', gap:'5px', alignItems:"center"}}>Updated Sets<Styled>
                                      <Tooltip
                                        placement="bottom"
                                        title={`This is the updated number of total sets to be processed on this cutter after a few sets were cancelled`}
                                        className="edit-tooltip"
                                      >
                                          <Iconmoon
                                            icon="info_new"
                                            size={14}
                                            color="black"
                                            style={{
                                              // opacity: 0.7,
                                              // marginTop: "2px",
                                              float: "right",
                                            }}
                                          />
                                      </Tooltip>
                                    </Styled></span>
                                <p>
                                  {jobCard?.jobcard[
                                    `solution_${acceptedSolution.key}`
                                  ].data.summary?.new_total_cutting_partitions
                                    ? jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary.new_total_cutting_partitions
                                    : 0}{" "}
                                </p>
                              </Col>{" "}
                            </Row>{" "}
                            </CollapsePanel></>
                            :
                            <>
                              <CollapsePanel key="3" header="Rewinding">
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Net Rewinding Qty</span>{" "}
                                    <p>
                                      {jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary?.net_rewinding_quantity
                                        ? jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary.net_rewinding_quantity.toFixed(
                                            3
                                          )
                                        : 0}{" "}
                                      {jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary?.units?.net_rewinding_quantity
                                        ? capitalize(
                                            weightUnit[
                                              jobCard?.jobcard[
                                                `solution_${acceptedSolution.key}`
                                              ].data.summary?.units
                                                .net_rewinding_quantity
                                            ]?.displayName
                                          )
                                        : "T"}
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Trim Loss</span>
                                    <p>
                                      {jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary?.rewinding_net_trim_loss
                                        ? jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary.rewinding_net_trim_loss.toFixed(
                                            3
                                          )
                                        : 0}{" "}
                                      {jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary?.units?.rewinding_net_trim_loss
                                        ? capitalize(
                                            weightUnit[
                                              jobCard?.jobcard[
                                                `solution_${acceptedSolution.key}`
                                              ].data.summary?.units
                                                .rewinding_net_trim_loss
                                            ]?.displayName
                                          )
                                        : "T"}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Rewinder</span>{" "}
                                    <p>
                                      {
                                        jobCard?.jobcard?.group.machines?.filter(
                                          (item) => item.machine_type === "rewinder"
                                        )[0]?.rewinder_name
                                      }
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Processed Order Qty</span>
                                    <p>
                                      {jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary
                                        ?.rewinder_processed_order_quantity
                                        ? jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary.rewinder_processed_order_quantity.toFixed(
                                            3
                                          )
                                        : 0}{" "}
                                      {jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary?.units
                                        ?.rewinder_processed_order_quantity
                                        ? capitalize(
                                            weightUnit[
                                              jobCard?.jobcard[
                                                `solution_${acceptedSolution.key}`
                                              ].data.summary?.units
                                                .rewinder_processed_order_quantity
                                            ]?.displayName
                                          )
                                        : "T"}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Number of Unique Sets</span>{" "}
                                    <p>
                                      {jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary?.unique_rewinding_partitions
                                        ? jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary.unique_rewinding_partitions
                                        : 0}{" "}
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Total Number of Sets</span>
                                    <p>
                                      {jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary?.total_rewinding_partitions
                                        ? jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary.total_rewinding_partitions
                                        : 0}{" "}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                              </CollapsePanel>
                              <CollapsePanel key="4" header="Cutting">
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Net Cutting Qty</span>{" "}
                                    <p>
                                      {jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary?.net_cutting_quantity
                                        ? jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary.net_cutting_quantity.toFixed(
                                            3
                                          )
                                        : 0}{" "}
                                      {jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary?.units?.net_cutting_quantity
                                        ? capitalize(
                                            weightUnit[
                                              jobCard?.jobcard[
                                                `solution_${acceptedSolution.key}`
                                              ].data.summary?.units
                                                .net_cutting_quantity
                                            ]?.displayName
                                          )
                                        : "T"}
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Trim Loss</span>
                                    <p>
                                      {jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary?.cutting_net_trim_loss
                                        ? jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary.cutting_net_trim_loss.toFixed(
                                            3
                                          )
                                        : 0}{" "}
                                      {jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary?.units?.cutting_net_trim_loss
                                        ? capitalize(
                                            weightUnit[
                                              jobCard?.jobcard[
                                                `solution_${acceptedSolution.key}`
                                              ].data.summary?.units
                                                .cutting_net_trim_loss
                                            ]?.displayName
                                          )
                                        : "T"}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Cutter</span>{" "}
                                    <p>
                                      {
                                        jobCard?.jobcard?.group.machines?.filter(
                                          (item) => item.machine_type === "cutter"
                                        )[0]?.cutter_name
                                      }
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Processed Order Qty</span>
                                    <p>
                                      {jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary
                                        ?.cutting_processed_order_quantity
                                        ? jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary.cutting_processed_order_quantity.toFixed(
                                            3
                                          )
                                        : 0}{" "}
                                      {jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary?.units
                                        ?.cutting_processed_order_quantity
                                        ? capitalize(
                                            weightUnit[
                                              jobCard?.jobcard[
                                                `solution_${acceptedSolution.key}`
                                              ].data.summary?.units
                                                .cutting_processed_order_quantity
                                            ]?.displayName
                                          )
                                        : "T"}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                                <Row
                                  span={24}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0px",
                                  }}
                                >
                                  {" "}
                                  <Col span={11}>
                                    <span>Number of Unique Sets</span>{" "}
                                    <p>
                                      {jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary?.unique_cutting_partitions
                                        ? jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary.unique_cutting_partitions
                                        : 0}{" "}
                                    </p>
                                  </Col>
                                  <Col span={11}>
                                    <span>Total Number of Sets</span>
                                    <p>
                                      {jobCard?.jobcard[
                                        `solution_${acceptedSolution.key}`
                                      ].data.summary?.total_cutting_partitions
                                        ? jobCard?.jobcard[
                                            `solution_${acceptedSolution.key}`
                                          ].data.summary.total_cutting_partitions
                                        : 0}{" "}
                                    </p>
                                  </Col>{" "}
                                </Row>{" "}
                              </CollapsePanel>
                          </>}
                        </Collapse>

                      {jobCard.comments.length &&
                      jobCard.comments[jobCard.comments.length - 1] ? (
                        <div className="alertmsd">
                          <h4>Reason for Cancellation</h4>
                          <AlertContainer
                            color="red"
                            icon={alertRed}
                            msg={jobCard.comments[jobCard.comments.length - 1]}
                          />
                        </div>
                      ) : null}
                    </div>
                  </Panes>
                  {(jobCard.state === "in_production" || jobCard.state === 'complete') && (
                    <Panes tab="Map Jumbo Reels" key="2">
                      <HaberForm className="mapped-col">
                        <Form name="basic" autoComplete="off">
                          <Row gutter={10} span={24}>
                            <Col span={6}>
                              <Form.Item
                                name="leftTrim"
                                label="Left Edge Trim"
                                initialValue={jobCard.jobcard.group.machines[0].left_edge_trim.toFixed(
                                  3
                                )}
                                className="dBlock"
                              >
                                <Input
                                  disabled
                                  suffix={
                                    jobCard.jobcard.group.machines[0]?.units &&
                                    jobCard.jobcard.group.machines[0]?.units
                                      .left_edge_trim
                                      ? lengthUnit[
                                          jobCard.jobcard.group.machines[0]
                                            ?.units.left_edge_trim
                                        ]?.displayName?.toUpperCase()
                                      : "CM"
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col span={6}>
                              <Form.Item
                                name="rightTrim"
                                label="Right Edge Trim"
                                initialValue={jobCard.jobcard.group.machines[0].right_edge_trim.toFixed(
                                  3
                                )}
                                className="dBlock"
                              >
                                <Input
                                  disabled
                                  suffix={
                                    jobCard.jobcard.group.machines[0]?.units &&
                                    jobCard.jobcard.group.machines[0]?.units
                                      .right_edge_trim
                                      ? lengthUnit[
                                          jobCard.jobcard.group.machines[0]
                                            ?.units.right_edge_trim
                                        ]?.displayName?.toUpperCase()
                                      : "CM"
                                  }
                                />
                              </Form.Item>
                            </Col>
                            <Col span={6}>
                              <Form.Item
                                name="decklewWidth"
                                label={
                                  jobCard.jobcard.group.grouping_params
                                    .core_id &&
                                  jobCard.jobcard.group.grouping_params
                                    .reel_od &&
                                  jobCard.jobcard.group.machines[0]
                                    .machine_type !== "cutter"
                                    ? "Deckle Width"
                                    : "Maximum Deckle Width"
                                }
                                initialValue={
                                  jobCard.jobcard.group.machines[0]
                                    .machine_type !== "cutter"
                                    ? (
                                        jobCard.jobcard.group.machines[0]
                                          .deckle_size_ub +
                                        (jobCard.jobcard.group.machines[0]
                                          .left_edge_trim +
                                        jobCard.jobcard.group.machines[0]
                                          .right_edge_trim) * CoversionFactorUnitsToCM[jobCard.jobcard.group
                                            .machines[0].units
                                            ?.right_edge_trim] * CoversionFactorCMToUnits[jobCard.jobcard.group
                                              .machines[0].units
                                              ?.deckle_size_ub]
                                      ).toFixed(3)
                                    : (
                                        jobCard.jobcard.group.machines[0]
                                          .deckle_length_ub +
                                       ( jobCard.jobcard.group.machines[0]
                                          .left_edge_trim +
                                        jobCard.jobcard.group.machines[0]
                                          .right_edge_trim)* CoversionFactorUnitsToCM[jobCard.jobcard.group
                                            .machines[0].units
                                            ?.right_edge_trim] * CoversionFactorCMToUnits[jobCard.jobcard.group
                                              .machines[0].units
                                              ?.deckle_size_ub]
                                      ).toFixed(3)
                                }
                                className="dBlock"
                              >
                                <Input
                                  disabled
                                  suffix={
                                    jobCard.jobcard.group.machines[0].units &&
                                    jobCard.jobcard.group.machines[0].units
                                      .deckle_size_ub
                                      ? lengthUnit[
                                          jobCard.jobcard.group.machines[0]
                                            .units.deckle_size_ub
                                        ]?.displayName?.toUpperCase()
                                      : "CM"
                                  }
                                />
                              </Form.Item>
                            </Col>
                            {jobCard.jobcard.group.grouping_params.core_id &&
                            jobCard.jobcard.group.grouping_params.reel_od &&
                            jobCard.jobcard.group.machines[0].machine_type !==
                              "cutter" ? (
                              <Col span={6}>
                                <Form.Item
                                  name="CoreOD/ReelOD"
                                  label="Core OD / Reel OD"
                                  initialValue={`${jobCard.jobcard.group.grouping_params.core_id} / ${jobCard.jobcard.group.grouping_params.reel_od}`}
                                  className="dBlock"
                                >
                                  <Input
                                    disabled
                                    suffix={
                                      jobCard.jobcard.group.grouping_params
                                        .units &&
                                      jobCard.jobcard.group.grouping_params
                                        .units.reel_od
                                        ? lengthUnit[
                                            jobCard.jobcard.group
                                              .grouping_params.units.reel_od
                                          ]?.displayName.toUpperCase()
                                        : "CM"
                                    }
                                  />
                                </Form.Item>
                              </Col>
                            ) : null}
                          </Row>
                        </Form>
                      </HaberForm>
                      <TableLayoutData>
                        <div
                          className="tableDataFormat "
                          style={{ marginTop: "25px" }}
                        >
                          {isMapJumboLoading ? <TableShimmer
                              header={jobCard.jobcard.group.machines[0].machine_type !==
                                "cutter"
                                  ? mapJumboReelColumns.filter(
                                      (item) => item.dataIndex !== "chop_size"
                                    )
                                  : mapJumboReelColumns.filter(
                                      (item) => item.dataIndex !== "diaValue"
                                    )}
                            scroll={2000}
                          /> :
                          <Table
                            columns={
                              jobCard.jobcard.group.machines[0].machine_type !==
                              "cutter"
                                ? mapJumboReelColumns.filter(
                                    (item) => item.dataIndex !== "chop_size"
                                  )
                                : mapJumboReelColumns.filter(
                                    (item) => item.dataIndex !== "diaValue"
                                  )
                            }
                            dataSource={jumboReelData}
                            onChange={onChange}
                            scroll={{ x: window.screen.width < 1500 && 1150 }}
                            pagination={{
                              total: jumboReelData ? jumboReelData.length : 0,
                              showTitle: false,
                              showTotal: (total, range) =>
                                `Showing ${range[0]}-${range[1]} of ${total} results`,
                            }}
                          />}
                        </div>
                      </TableLayoutData>
                    </Panes>
                  )}
                  <Panes tab="Size Fulfilment" key="3">
                    <TableLayoutData>
                      <div
                        className="tableDataFormat  "
                        style={{ marginTop: "25px" }}
                      >
                        <Table
                          columns={sizeFulfillmentColumnsHead}
                          dataSource={sizeFulfillmentDetailsList}
                          onChange={onChange}
                          scroll={{ x: 800 }}
                          rowClassName={(record) => record.priority && "true"}
                          pagination={{
                            total: sizeFulfillmentDetailsList?.length,
                            showTitle: false,
                            showTotal: (total, range) =>
                              `Showing ${range[0]}-${range[1]} of ${total} results`,
                          }}
                        />
                      </div>
                    </TableLayoutData>
                  </Panes>
                  <Panes tab="Fulfilled Orders" key="4">
                    <TableLayoutData>
                      <div
                        className="tableDataFormat "
                        style={{ marginTop: "25px" }}
                      >{isFetchingData ? (
                        <TableShimmer
                          header={columnsHead}
                          scroll={1600}
                        />
                      ) : (
                        <Table
                          columns={columnsHead}
                          dataSource={orderDetailsList?.filter(
                            (order) => order.fulflilledReels > 0
                          )}
                          onChange={onChange}
                          scroll={{ x: 1600 }}
                          rowClassName={(record) => record.priority && "true"}
                          pagination={{
                            current: currentPage,
                            pageSize: pageSize,
                            total: totalFulfilledOrders,
                            onChange:
                              onPaginationChange,
                            showSizeChanger: true,
                            showQuickJumper: true,
                            // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                          }}
                        />)}
                      </div>
                    </TableLayoutData>
                  </Panes>
                  <Panes tab="Unfulfilled Orders" key="5">
                    <TableLayoutData>
                      <div
                        className="tableDataFormat"
                        style={{ marginTop: "25px" }}
                      >{isFetchingData ? (
                        <TableShimmer
                          header={unfulfilledColumnsHead}
                          scroll={1600}
                        />
                      ) : (
                        <Table
                          columns={unfulfilledColumnsHead}
                          dataSource={orderDetailsList?.filter(
                            (order) =>
                              parseFloat(
                                order.unFulflilledWeight.split(" ")[0]
                              ) > 0
                          )}
                          onChange={onChange}
                          scroll={{ x: 1600 }}
                          rowClassName={(record) => record.priority && "true"}
                          pagination={{
                            current: currentPage,
                            pageSize: pageSize,
                            total: totalUnfulfilledOrders,
                            onChange:
                              onPaginationChange,
                            showSizeChanger: true,
                            showQuickJumper: true,
                            // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                          }}
                        />)}
                      </div>
                    </TableLayoutData>
                  </Panes>
                  <Panes
                    tab="Intermediate Reels"
                    key="6"
                    // disabled={solutionSummary?.solution1.exception}
                  >
                    <TableLayoutData>
                      <div
                        className="tableDataFormat"
                        style={{ marginTop: "25px" }}
                      >
                        <Table
                          columns={intermediateColumnsHead}
                          dataSource={intermediateData}
                          onChange={onChange}
                          scroll={{ x: 1000 }}
                          rowClassName={(record) => record.priority && "true"}
                        />
                      </div>
                    </TableLayoutData>
                  </Panes>
                </Tabs>
              </Col>
            </Row>
            </div>
            </SolutionContainer>
        </DetailFields>

        {toaster && actionResponse && (
          <AlertContainer
            color={`${actionResponse.error ? "red" : "green"} toaster`}
            icon={actionResponse.error ? alertRed : alertGreen}
            msg={capitalize(actionResponse.msg)}
          />
        )}

        <ConfirmationModal
          visible={visible}
          icon={warning}
          cancelAction={closeModal}
          confirmAction={modalConfirm}
        >
          <span>Are you sure ?</span>
          <p>
            You are about to start production for this job card, are you sure
            you want to continue?
          </p>
        </ConfirmationModal>

        {jobCard?.jobcard?.group?.machines[0]?.machine_type !== "cutter" ? (
          <ConfirmationModal
            visible={visibleHold}
            icon={warning}
            cancelAction={holdModalClose}
            confirmAction={holdModalConfirm}
          >
            <span>Hold production?</span>
            <p>
              The production for this job card will be put on hold. You cannot
              make any changes to the mapping and cannot print rewinding
              details. Are you sure you want to continue?
            </p>
          </ConfirmationModal>
        ) : (
          <ConfirmationModal
            visible={visibleHold}
            icon={warning}
            cancelAction={holdModalClose}
            confirmAction={holdModalConfirm}
          >
            <span>Hold production?</span>
            <p>
              The production for this job card will be put on hold. You cannot
              make any changes to the mapping and cannot print cutting details.
              Are you sure you want to continue?
            </p>
          </ConfirmationModal>
        )}

        {/* <ConfirmationModal
          visible={visibleCancel}
          icon={warning}
          cancelAction={cancelModalClose}
          confirmAction={cancelModalConfirm}
        >
          <span>Cancel Production?</span>
          <p>
            The orders in this job card will be reverted to pending quantity and
            job card cannot be used for production. Are you sure you want to
            continue?
          </p>
        </ConfirmationModal> */}
      </ResultWrap>

      <CancelJobCardDrawer
        jobId={jobId}
        visible={viewCancelJobCardDrawer}
        onClose={closeCancelJobCardDrawer}
        setActionResponse={setActionResponse}
        showToaster={showToaster}
        reFetch={setReFetch}
        onCancelSuccess={onCancelSuccess}
        isCancelLoadingToggle={(isFetching) => {isCancelLoadingToggle(isFetching) }}
      />

      {viewParentReelJobCardDrawer && (
        <ParentReelJobCardDrawer
          parentReelId={selectedParentReel}
          visible={viewParentReelJobCardDrawer}
          onCloseParentReelCancel={onCloseParentReelCancel}
          onClose={closeParentReelJobCard}
          isProduced={isProduced}
        />
      )}

      {viewCloseProductionDrawer && (
        <ClosedProductionDrawer
          jobId={jobId}
          parentReelId={selectedParentReel}
          visible={viewCloseProductionDrawer}
          onCloseProduction={closeProduction}
          setActionResponse={setActionResponse}
          showToaster={showToaster}
          reFetch={setReFetchJumboReels}
          type={type}
          data={resp}
          drawerState={isDrawerOpened}
          machineCode={jobCard.jobcard.group.machines[0]["machine_id"]}
          productCode={jobCard.jobcard.group.product["code"]}
          productSpec={jobCard.jobcard.group.product["product_spec"]}
          parentWeight={parentWeight}
          parentWeightUnit={parentWeightUnit}
          savedDate={savedDate}
          savedShift={savedShift}
          selectedMachineType={selectedMachineType}
        />
      )}

      {viewMapToReelDrawer && (
        <MapToJumboDrawer
          jobId={jobId}
          parentReelId={selectedParentReel}
          visible={viewMapToReelDrawer}
          onCloseMapToReel={closeMapToReel}
          setActionResponse={setActionResponse}
          showToaster={showToaster}
          reFetch={setReFetchJumboReels}
          type={type}
          data={resp}
          drawerState={isDrawerOpened}
          machineCode={jobCard.jobcard.group.machines[0]["machine_id"]}
          productCode={jobCard.jobcard.group.product["code"]}
          productSpec={jobCard.jobcard.group.product["product_spec"]}
          parentWeight={parentWeight}
          parentWeightUnit={parentWeightUnit}
          savedDate={savedDate}
          savedShift={savedShift}
          selectedMachineType={selectedMachineType}
        />
      )}

      <CancelProductionDrawer
        jobId={jobId}
        parentReelId={selectedParentReel}
        visible={viewCancelProductionDrawer}
        onCloseCancelProduction={closeCancelProduction}
        onBackCancel={onCloseCancelBack}
        showToaster={showToaster}
        setActionResponse={setActionResponse}
        reFetch={setReFetchJumboReels}
      />

      <ViewDeckleOrder
        selectedOrderNo={selectedOrderNo}
        // showButton={true}
        visible={viewOrder}
        onClose={closeViewDrawer}
        onCloseGrade={closeViewDrawer}
        category={selectedOrder?.category}

      />
    </RightLayoutContainer>
  ) : (
    <RightLayoutContainer>
      {/* {console.log("Jobcard", jobCard)} */}
      <PageTitleComp className="marginRightAdg" style={{ borderBottom: "0px" }}>
        <PageHeader
          ghost={false}
          onBack={() => navigate("../job-cards")}
          title="Job Card Details"
          
        ></PageHeader>
      </PageTitleComp>
      <ResultWrap>
        <DetailFields
          className="jobCardView"
          style={{ justifyContent: "flex-start" }}
        >
           <PageTitleComp style={{ borderBottom: "0" }}>
            <PageHeader
              ghost={false}
             // title={`Job Card ${jobCard.id}`}
              className="jobCardList-Grid"
            ></PageHeader>

            <div
              className={`jobCardList ${"fullWidth"}`}
              style={{
                alignSelf: "center",
                display: "flex",
                marginTop:
                  isParentReelCancelled && activeTab >= 2 ? "20px" : "34px",
                // alignContent:'top'
              }}
            >
              {/* <JobCardColorStatus>
                <div className="statusVal" dataval={jobCard.state}>
                  {jobcardState(jobCard.state)}
                </div>
              </JobCardColorStatus> */}
             
            </div>
            {isParentReelCancelled && activeTab >= 2 && (
              <Col span={9} style={{ display: "absolute" }}>
                <div
  className="cancelledSetMessage"
  style={{
    display: "flex",
    justifyContent: "center", // Center content horizontally
    alignItems: "center", // Center content vertically
    marginTop: "25px",
    borderRadius: "4px",
    backgroundColor: "#f4f0ec",
    padding: "4px 6px",
    opacity: 0.95,
  }}
>
  {/* <div className="centerAlignMeVertically" style={{ padding: "2px 6px 0px 3px" }}>
    <Iconmoon icon="warning_new" size={20} style={{ color: "#808080" }} />
  </div>
  <span style={{ fontSize: "14px", color: "#555555" }}>
    A few sets were cancelled in this job card. Hence, fulfilled
    quantity might not be accurate for the cancelled sets.
  </span> */}
</div>

              </Col>
            )}
          </PageTitleComp>

          <div className="MatchResult JobResulted">
            <Row span={24}>
              <Col
                span={15}
                className="pipeBlock"
                style={{
                  paddingRight: "20px",
                  transform:
                    isParentReelCancelled && activeTab >= 2
                      ? "translateY(-14px)"
                      : "",
                }}
              >
                 <div style={{
            paddingTop: "50px",
            paddingBottom: "50px"}}
        >
             <CardShimmerStyle >
            <div 
            style={{display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                opacity:"70%",
                width: "341.62px",
                marginTop:'60px'
          }}
            >
       <Skeleton.Image active={true}  style={{width:'105px',marginLeft:'auto',marginRight:'auto'}}/>

              </div>
              </CardShimmerStyle>
            {/* <div 
            style={{
                fontFamily: "var(--sf-pro-display-m)",
                fontWeight: "500",
                fontSize: "14px",
                height: "16px",
                color: "#A19F9D",
                paddingTop: "20px",
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                width: "150px",
                textAlign: "center",
           }}
           >{heading}
            </div> */}
            <div style={{
                        paddingTop: "30px",
                        fontFamily: "var(--sf-pro-display-m)",
                        fontWeight: "400",
                        fontSize: "12px",
                        height: "20px",
                        color: "#A19F9D",
                        display: "block",
                        marginLeft: "auto",
                        marginRight: "auto",
                        width: "311px",
                        textAlign: "center"}}
                        >
            { "Fetching jobcard details" }
            </div>
           
        </div>
              </Col>
              <Col span={9} className="colLayoutBlock leftPostTab">
                <Tabs
                  defaultActiveKey="1"
                  activeKey={activeTab}
                  onChange={tabChange}
                  className="topPostTab innerPostTab"
                >
                  <Panes tab="Summary" key="1">
                    <div className="lossValue">
                      <Row span={24} style={{ paddingTop: "10px" }}>
                        <Col span={12}>
                          <div
                            className={
                              "summaryValue"
                            }
                            style={{padding:'0px'}}
                          >
                            <CardShimmerStyle >
                              <div style={{width:'100%',display:'flex'}}>
                        <div style={{flexDirection:'row',display:'flex',width:'100%'}}>
                    <Skeleton.Button  active={true}  style={{height:'100px'}}></Skeleton.Button>
                          </div>
                          </div>
                          </CardShimmerStyle>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div
                            className={
                              "summaryValue"
                            }
                            style={{padding:'0px'}}
                          >
                            <CardShimmerStyle >
                              <div style={{width:'100%',display:'flex'}}>
                        <div style={{flexDirection:'row',display:'flex',width:'100%'}}>
                    <Skeleton.Button  active={true}  style={{height:'100px'}}></Skeleton.Button>
                          </div>
                          </div>
                          </CardShimmerStyle>
                          </div>
                        </Col>
                            
                          
                      </Row>
                     
                      <Row span={24} style={{ paddingTop: "10px" }}>
                        <Col span={12}>
                          <div
                            className={
                              "summaryValue"
                            }
                            style={{padding:'0px'}}
                          >
                            <CardShimmerStyle >
                              <div style={{width:'100%',display:'flex'}}>
                        <div style={{flexDirection:'row',display:'flex',width:'100%'}}>
                    <Skeleton.Button  active={true}  style={{height:'100px'}}></Skeleton.Button>
                          </div>
                          </div>
                          </CardShimmerStyle>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div
                            className={
                              "summaryValue"
                            }
                            style={{padding:'0px'}}
                          >
                            <CardShimmerStyle >
                              <div style={{width:'100%',display:'flex'}}>
                        <div style={{flexDirection:'row',display:'flex',width:'100%'}}>
                    <Skeleton.Button  active={true}  style={{height:'100px'}}></Skeleton.Button>
                          </div>
                          </div>
                          </CardShimmerStyle>
                          </div>
                        </Col>
                            
                          
                      </Row>

                      <Row span={24} style={{ paddingTop: "10px" }}>
                        <Col span={12}>
                          <div
                            className={
                              "summaryValue"
                            }
                            style={{padding:'0px'}}
                          >
                            <CardShimmerStyle >
                              <div style={{width:'100%',display:'flex'}}>
                        <div style={{flexDirection:'row',display:'flex',width:'100%'}}>
                    <Skeleton.Button  active={true}  style={{height:'60px'}}></Skeleton.Button>
                          </div>
                          </div>
                          </CardShimmerStyle>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div
                            className={
                              "summaryValue"
                            }
                            style={{padding:'0px'}}
                          >
                            <CardShimmerStyle >
                              <div style={{width:'100%',display:'flex'}}>
                        <div style={{flexDirection:'row',display:'flex',width:'100%'}}>
                    <Skeleton.Button  active={true}  style={{height:'60px'}}></Skeleton.Button>
                          </div>
                          </div>
                          </CardShimmerStyle>
                          </div>
                        </Col>
                            
                          
                      </Row>
                      <Row span={24} style={{ paddingTop: "10px" }}>
                        <Col span={12}>
                          <div
                            className={
                              "summaryValue"
                            }
                            style={{padding:'0px',backgroundColor:'white'}}
                          >
                            <CardShimmerStyle >
                              <div style={{width:'70%',display:'flex'}}>
                        <div style={{flexDirection:'row',display:'flex',width:'100%'}}>
                    <Skeleton.Button  active={true}  style={{height:'20px'}}></Skeleton.Button>
                          </div>
                          </div>
                          </CardShimmerStyle>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div
                            className={
                              "summaryValue"
                            }
                            style={{padding:'0px',backgroundColor:'white'}}
                          >
                            <CardShimmerStyle >
                              <div style={{width:'70%',display:'flex'}}>
                        <div style={{flexDirection:'row',display:'flex',width:'100%'}}>
                    <Skeleton.Button  active={true}  style={{height:'20px'}}></Skeleton.Button>
                          </div>
                          </div>
                          </CardShimmerStyle>
                          </div>
                        </Col>
                            
                          
                      </Row>
                     
                    </div>
                  </Panes>
                  <Panes tab="Size Fulfilment" key="2">
                 {/* { acceptedSolution.solution.data.parent_reel_cancelled ? <AlertContainer
                      color="blue"
                      icon={warningjob}
                      msg="A few sets were cancelled in this job card. Hence, fulfilled quantity might not be accurate for the cancelled sizes."
                      removeBottomMargin={true}
                      jobCard = {true}
                    /> : ''} */}
                    <TableLayoutData>
                      <div
                        className="tableDataFormat  "
                        style={{ marginTop: "25px" }}
                      >
                        <TableShimmer
                          header={sizeFulfillmentColumnsHead}
                          scroll={1300}
                        />
                        
                      </div>
                    </TableLayoutData>
                  </Panes>
                  <Panes tab="Fulfilled Orders" key="3">
                    <TableLayoutData>
                      <div
                        className="tableDataFormat  "
                        style={{ marginTop: "25px" }}
                      > 
                        <TableShimmer
                          header={columnsHead}
                          scroll={1600}
                        />
                     
                      </div>
                    </TableLayoutData>
                  </Panes>
                  <Panes tab="Unfulfilled Orders" key="4">
                  {/* { acceptedSolution.solution.data.parent_reel_cancelled ? <AlertContainer
                      color="blue"
                      icon={warningjob}
                      msg="A few sets were cancelled in this job card. Hence, fulfilled quantity might not be accurate for the cancelled sizes."
                      removeBottomMargin={true}
                      jobCard = {true}
                    /> : ''} */}
                    <TableLayoutData>
                      <div
                        className="tableDataFormat"
                        style={{ marginTop: "25px" }}
                      >
                       
                        <TableShimmer
                          header={unfulfilledColumnsHead}
                          scroll={1300}
                        />
                      
                      </div>
                    </TableLayoutData>
                  </Panes>
                  <Panes
                    tab="Intermediate Reels"
                    key="5"
                    // disabled={solutionSummary?.solution1.exception}
                  >
                    {/* { acceptedSolution.solution.data.parent_reel_cancelled ? <AlertContainer
                      color="blue"
                      icon={warningjob}
                      msg="A few sets were cancelled in this job card. Hence, fulfilled quantity might not be accurate for the cancelled sizes."
                      removeBottomMargin={true}
                      jobCard = {true}
                    /> : ''} */}
                    <TableLayoutData>
                      <div
                        className="tableDataFormat"
                        style={{ marginTop: "25px" }}
                      >
                         <TableShimmer
                          header={intermediateColumnsHead}
                          scroll={1300}
                        />
                      
                      </div>
                    </TableLayoutData>
                  </Panes>
                </Tabs>
              </Col>
            </Row>
          </div>
        </DetailFields>
        {/* approve Modal */}
        
      </ResultWrap>
    </RightLayoutContainer>
  ) ;;
};
export default ProductionJobcardDetailsMultistage;
